import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { forwardRef, useCallback, useState, useEffect, useMemo, createElement, Component, createRef, useLayoutEffect, useRef, createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import { useIsMobile } from '@nbx/frontend-helpers/misc';
import { useTheme, useLang } from '@nbx/frontend-helpers/subscribe';
import { Link } from 'react-router-dom';
import { mountRootParcel } from 'single-spa';
import a$1 from 'single-spa-react/parcel';
import { publishErrorNotification } from '@nbx/frontend-helpers/publish';
import { formatAsset } from '@nbx/frontend-helpers/format';

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = '';

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}

			return classes;
		}

		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}

			if (typeof arg !== 'object') {
				return '';
			}

			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}

			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}

			var classes = '';

			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}

			return classes;
		}

		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}()); 
} (classnames));

var classnamesExports = classnames.exports;
var s$6 = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$v = ".Spinner-module_spinner__SZoUP {\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  border: 2px solid var(--color-grey);\n  border-top-color: var(--color-grey-dark);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  animation: Spinner-module_spin__Yk0wm 1s ease infinite;\n}\n@keyframes Spinner-module_spin__Yk0wm {\n  0% {\n    transform: translate(-50%, -50%) rotate(0deg);\n  }\n  100% {\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n}\n\n.Spinner-module_large__Dc4gW {\n  width: 48px;\n  height: 48px;\n  border-width: 3px;\n}";
var e$3 = {"spinner":"Spinner-module_spinner__SZoUP","spin":"Spinner-module_spin__Yk0wm","large":"Spinner-module_large__Dc4gW"};
styleInject(css_248z$v);

const Spinner = ({ large: m = !1 })=>jsx("div", {
        className: s$6(e$3.spinner, {
            [e$3.large]: m
        })
    });

var css_248z$u = "@keyframes Button-module_fadeIn__Hmhjf {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes Button-module_fadeOut__-4DEj {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n@keyframes Button-module_blinker__sw-6h {\n  50% {\n    opacity: 0.2;\n  }\n}\n.Button-module_big__KYHI- {\n  margin-left: 3rem;\n  margin-right: 3rem;\n}\n\n.Button-module_button__18Bed {\n  display: inline-block;\n  cursor: pointer;\n  outline: none;\n  position: relative;\n  font-family: inherit;\n  font-size: var(--v2-font-size-button);\n  font-weight: var(--font-weight-bold);\n  letter-spacing: 0.01em;\n  padding: calc(var(--button-height) / 20) calc(var(--button-height) / 2) 0px;\n  height: var(--button-height);\n  border-radius: calc(var(--button-height) / 2);\n  margin: 0;\n  background: var(--v2-button-bg);\n  color: var(--v2-text);\n  border: none;\n  width: auto;\n  transition: color var(--animation-theme), background var(--animation-theme), border-color var(--animation-theme), opacity var(--animation-theme);\n}\n.Button-module_button__18Bed.Button-module_square__3Z5nh {\n  padding: calc(var(--button-height) / 20) calc(var(--button-height) / 5) 0px;\n}\n.Button-module_button__18Bed:hover {\n  background: var(--v2-button-bg-hover);\n}\n.Button-module_button__18Bed > span {\n  line-height: 1;\n}\n\n.Button-module_label__1PsXG {\n  white-space: nowrap;\n  width: 100%;\n  height: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.Button-module_label__1PsXG.Button-module_square__3Z5nh {\n  flex-direction: column-reverse;\n  justify-content: space-around;\n}\n\n.Button-module_button__18Bed nbx-icon {\n  margin-left: 8px;\n}\n\n.Button-module_primary__st6yY {\n  height: 56px;\n  border-radius: 0px;\n  background: var(--v2-text);\n  color: var(--v2-antitext);\n  font-size: var(--v2-font-size-body);\n}\n.Button-module_primary__st6yY:hover {\n  background: var(--v2-text);\n  opacity: 0.8;\n}\n\na.Button-module_button__18Bed {\n  display: inline-block;\n  height: var(--button-height);\n  padding: 0px 18px;\n  text-decoration: none;\n}\na.Button-module_button__18Bed.Button-module_primary__st6yY {\n  height: 56px;\n}\n\n.Button-module_inverted__bGHmY {\n  background: var(--v2-text);\n  color: var(--v2-antitext);\n}\n.Button-module_inverted__bGHmY:hover {\n  opacity: 0.8;\n  background: var(--v2-text);\n}\n.Button-module_inverted__bGHmY.Button-module_primary__st6yY {\n  background: var(--v2-antitext);\n  color: var(--v2-text);\n}\n.Button-module_inverted__bGHmY.Button-module_primary__st6yY.Button-module_bordered__PPaJv {\n  border: 1px solid var(--v2-text);\n}\n\n.Button-module_disabled__UzdWL {\n  cursor: not-allowed;\n  opacity: 0.2;\n}\n.Button-module_disabled__UzdWL:hover.Button-module_inverted__bGHmY {\n  opacity: 0.2 !important;\n}\n.Button-module_disabled__UzdWL:hover:not(.Button-module_inverted__bGHmY) {\n  opacity: 0.2;\n}\n.Button-module_disabled__UzdWL:hover:not(.Button-module_primary__st6yY):not(.Button-module_inverted__bGHmY) {\n  background: var(--v2-button-bg);\n}\n\n.Button-module_fullWidth__AHpSl {\n  width: 100%;\n}\n\n.Button-module_invisible__yyUXO {\n  opacity: 0;\n}\n\n.Button-module_primarySpinner__vyxfq,\n.Button-module_invertedSpinner__BHxqS {\n  border-color: var(--color-grey);\n  border-top-color: var(--v2-antitext);\n}\n\n.Button-module_bordered__PPaJv {\n  border: var(--v2-border-width) solid var(--v2-border-color);\n}\n\n.Button-module_arrow__rLmow {\n  padding-left: 6px;\n  font-size: 1.2rem;\n}\n\n.Button-module_underline__C34KL:hover {\n  text-decoration: underline;\n}";
var r$6 = {"big":"Button-module_big__KYHI-","button":"Button-module_button__18Bed","square":"Button-module_square__3Z5nh","label":"Button-module_label__1PsXG","primary":"Button-module_primary__st6yY","inverted":"Button-module_inverted__bGHmY","bordered":"Button-module_bordered__PPaJv","disabled":"Button-module_disabled__UzdWL","fullWidth":"Button-module_fullWidth__AHpSl","invisible":"Button-module_invisible__yyUXO","primarySpinner":"Button-module_primarySpinner__vyxfq","invertedSpinner":"Button-module_invertedSpinner__BHxqS","arrow":"Button-module_arrow__rLmow","underline":"Button-module_underline__C34KL","fadeIn":"Button-module_fadeIn__Hmhjf","fadeOut":"Button-module_fadeOut__-4DEj","blinker":"Button-module_blinker__sw-6h"};
styleInject(css_248z$u);

const Button = ({ onClick: i, disabled: o = !1, children: t, inverted: l = !1, primary: d = !1, fullWidth: m = !1, big: c = !1, loading: p = !1, type: u, icon: b, bordered: f = !0, square: h = !1, className: x, slot: N, arrow: j = !1, underline: g = !1 })=>jsx("button", {
        onClick: i,
        className: s$6([
            r$6.button,
            x
        ], {
            [r$6.primary]: d,
            [r$6.loading]: p,
            [r$6.disabled]: o || p,
            [r$6.fullWidth]: m,
            [r$6.inverted]: l,
            [r$6.bordered]: f,
            [r$6.square]: h
        }),
        disabled: o || p,
        type: u,
        slot: N,
        children: p ? jsx(Spinner, {}) : jsxs("span", {
            className: s$6(r$6.label, {
                [r$6.big]: c,
                [r$6.square]: h
            }),
            children: [
                jsx("span", {
                    className: s$6({
                        [r$6.underline]: !f && g
                    }),
                    children: t
                }),
                b && jsx("nbx-icon", {
                    icon: b,
                    inverted: d && !l || !d && l,
                    size: 24
                }),
                j && jsx("span", {
                    className: r$6.arrow,
                    children: "\u2192"
                })
            ]
        })
    });

var css_248z$t = "@keyframes Field-module_fadeIn__Qf062 {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes Field-module_fadeOut__PYKNW {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n@keyframes Field-module_blinker__z7OnN {\n  50% {\n    opacity: 0.2;\n  }\n}\n.Field-module_field__dnDYN > label {\n  color: var(--v2-text);\n  font-size: var(--v2-font-size-body);\n}\n\n.Field-module_wrapField__QpvlT {\n  position: relative;\n}\n.Field-module_wrapField__QpvlT > input, .Field-module_wrapField__QpvlT > select {\n  height: var(--form-input-height);\n  width: 100%;\n  min-width: 50px;\n  padding: 0 16px;\n  margin-left: 0;\n  border: var(--v2-border-input-width) solid var(--v2-input-border);\n  font-size: var(--v2-font-size-body);\n  background-color: transparent;\n  color: var(--v2-text);\n  transition: color var(--v2-animation-theme), background-color var(--animation-theme);\n}\n.Field-module_wrapField__QpvlT > input > option, .Field-module_wrapField__QpvlT > select > option {\n  background-color: var(--v2-background);\n  color: var(--v2-text);\n  transition: color var(--v2-animation-theme), background-color var(--animation-theme);\n}\n.Field-module_wrapField__QpvlT > input::placeholder, .Field-module_wrapField__QpvlT > select::placeholder {\n  color: var(--v2-input-placeholder);\n}\n.Field-module_wrapField__QpvlT > input:disabled, .Field-module_wrapField__QpvlT > select:disabled {\n  cursor: not-allowed;\n  border: 1px solid var(--border);\n}\n.Field-module_wrapField__QpvlT > input:focus, .Field-module_wrapField__QpvlT > select:focus {\n  border: var(--v2-border-input-width) solid var(--primary);\n  outline: none;\n}\n.Field-module_wrapField__QpvlT > input.Field-module_error__dr2iV, .Field-module_wrapField__QpvlT > select.Field-module_error__dr2iV {\n  border: 2px solid var(--color-red-infra);\n}\n.Field-module_wrapField__QpvlT > input[type=number] {\n  appearance: textfield;\n}\n.Field-module_wrapField__QpvlT > input::-webkit-outer-spin-button, .Field-module_wrapField__QpvlT > input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n.Field-module_wrapField__QpvlT > input.Field-module_noLeftBorder__N-ipK {\n  border-left: none;\n}\n.Field-module_wrapField__QpvlT > input.Field-module_noBorder__qHBw- {\n  border: none;\n}\n\n.Field-module_fieldLabelWrap__FoZC0 {\n  margin-bottom: 0.5rem;\n}\n\n.Field-module_wrapBorderRadius__NV9MU {\n  border-radius: var(--border-radius-md);\n}\n\n.Field-module_small__4xvje {\n  max-width: 8rem;\n}\n\n.Field-module_medium__d05WN {\n  max-width: 12rem;\n}\n\n.Field-module_fieldError__IlT5t {\n  position: absolute;\n  color: var(--color-red-infra);\n  font-size: var(--v2-font-size-notification);\n  width: 100%;\n  margin-top: 0.2rem;\n  height: 1rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  animation: Field-module_fadeIn__Qf062 var(--animation-theme);\n  text-align: right;\n}\n\n.Field-module_trailingText__M3-Ju {\n  position: absolute;\n  right: 0;\n  padding-top: 1.2rem;\n  padding-right: 1.2rem;\n}\n\n.Field-module_fieldWithTrailingText__MVBtj > input, .Field-module_fieldWithTrailingText__MVBtj > select {\n  padding-right: 64px;\n}\n\n.Field-module_textAlignCenter__Nnw2- {\n  text-align: center;\n}";
var r$5 = {"field":"Field-module_field__dnDYN","wrapField":"Field-module_wrapField__QpvlT","error":"Field-module_error__dr2iV","noLeftBorder":"Field-module_noLeftBorder__N-ipK","noBorder":"Field-module_noBorder__qHBw-","fieldLabelWrap":"Field-module_fieldLabelWrap__FoZC0","wrapBorderRadius":"Field-module_wrapBorderRadius__NV9MU","small":"Field-module_small__4xvje","medium":"Field-module_medium__d05WN","fieldError":"Field-module_fieldError__IlT5t","fadeIn":"Field-module_fadeIn__Qf062","trailingText":"Field-module_trailingText__M3-Ju","fieldWithTrailingText":"Field-module_fieldWithTrailingText__MVBtj","textAlignCenter":"Field-module_textAlignCenter__Nnw2-","fadeOut":"Field-module_fadeOut__PYKNW","blinker":"Field-module_blinker__z7OnN"};
styleInject(css_248z$t);

const Field = forwardRef(({ id: t, autoFocus: n = !1, autoComplete: s = !0, label: o, type: m = 'text', options: c, onValueChange: u, onChange: h, onBlur: f, maxLength: p, value: x, defaultValue: v, placeholder: b, error: g, noErrorLabel: N, isDisabled: F = !1, isShowLabel: j = !0, noLabel: B = !1, trailingText: C, min: L, max: T, className: w, textAlign: V = 'left', isBorderRadius: W = !0, noLeftBorder: y = !1, size: A }, E)=>{
    let O = useCallback((e)=>{
        u && u(e.currentTarget.value);
    }, []);
    return jsxs("div", {
        className: s$6(r$5.field, {
            [r$5.small]: 'small' === A,
            [r$5.medium]: 'medium' === A
        }, w),
        children: [
            j && jsx("div", {
                className: r$5.fieldLabelWrap,
                children: jsx("nbx-text", {
                    label: !0,
                    children: jsx("label", {
                        htmlFor: t,
                        className: r$5.fieldLabel,
                        children: o
                    })
                })
            }),
            jsx("div", {
                className: s$6(r$5.wrapField, {
                    [r$5.fieldWithTrailingText]: !!C,
                    [r$5.wrapBorderRadius]: W
                }),
                children: c ? jsxs("select", {
                    id: t,
                    value: x,
                    onChange: h,
                    onBlur: h,
                    defaultValue: null != v ? v : '',
                    disabled: F,
                    children: [
                        jsx("option", {
                            disabled: !0,
                            value: '',
                            children: b
                        }),
                        Object.entries(c).map(([l, a])=>jsx("option", {
                                value: l,
                                children: a
                            }, l))
                    ]
                }) : jsxs(Fragment, {
                    children: [
                        C && jsx("span", {
                            className: r$5.trailingText,
                            children: jsx("nbx-text", {
                                children: C
                            })
                        }),
                        jsx("input", {
                            ref: E,
                            id: t,
                            className: s$6([
                                {
                                    [r$5.error]: g,
                                    [r$5.textAlignCenter]: 'center' === V,
                                    [r$5.noLeftBorder]: y
                                }
                            ]),
                            placeholder: b,
                            type: m,
                            value: null != x ? x : '',
                            defaultValue: v || void 0,
                            onChange: u ? O : h,
                            onBlur: u ? O : h,
                            maxLength: p,
                            autoFocus: n,
                            autoComplete: s ? void 0 : 'off',
                            disabled: F,
                            min: L,
                            max: T
                        })
                    ]
                })
            }),
            !N && g && jsx("div", {
                className: r$5.fieldError,
                children: g
            })
        ]
    });
});

var css_248z$s = ".Message-module_message__UaN2I {\n  height: 100%;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n}\n\n.Message-module_center__AI6kU {\n  justify-content: center;\n  align-items: center;\n}\n\n.Message-module_content__3lMol {\n  margin-top: 5rem;\n}\n\n.Message-module_border__rbSD4 {\n  border: 1px solid var(--v2-card-border-color);\n  border-radius: var(--v2-card-border-radius);\n}";
var t$5 = {"message":"Message-module_message__UaN2I","center":"Message-module_center__AI6kU","content":"Message-module_content__3lMol","border":"Message-module_border__rbSD4"};
styleInject(css_248z$s);

const Message = ({ text: o, children: a, onClose: m, center: c = !0, border: l = !1, ariaLabel: i })=>{
    let { t: d } = useTranslation();
    return jsxs("div", {
        className: s$6(t$5.message, {
            [t$5.center]: c,
            [t$5.border]: l
        }),
        "aria-label": null != i ? i : 'message',
        children: [
            o && jsx("nbx-text", {
                children: o
            }),
            a && jsx("div", {
                className: t$5.content,
                children: a
            }),
            m && jsx("nbx-button", {
                onClick: m,
                children: d('common_close')
            })
        ]
    });
};

var css_248z$r = ".Loading-module_loading__7gLQd {\n  position: relative;\n  min-height: 2rem;\n  margin: 2rem auto;\n  display: flex;\n}\n\n.Loading-module_text__CGqMR {\n  padding-top: 6rem;\n}";
var r$4 = {"loading":"Loading-module_loading__7gLQd","text":"Loading-module_text__CGqMR"};
styleInject(css_248z$r);

const Loading = ({ text: s })=>jsxs("div", {
        className: r$4.loading,
        "aria-label": "loading",
        children: [
            jsx(Spinner, {
                large: !0
            }),
            s && jsx("div", {
                className: r$4.text,
                children: jsx("nbx-text", {
                    muted: !0,
                    children: s
                })
            })
        ]
    });

var css_248z$q = ".Img-module_assetImg__LMJO0 {\n  height: 8rem;\n}\n\n.Img-module_small__KTfti {\n  height: 4rem;\n}\n\n.Img-module_big__7L9xG {\n  height: 12rem;\n}";
var m = {"assetImg":"Img-module_assetImg__LMJO0","small":"Img-module_small__KTfti","big":"Img-module_big__7L9xG"};
styleInject(css_248z$q);

const Img = ({ fileName: l, alt: r, size: t })=>jsx("img", {
        className: s$6(m.assetImg, {
            [m.big]: 'big' === t,
            [m.small]: 'small' === t
        }),
        src: `/assets/images/${l}`,
        alt: null != r ? r : l
    });

var css_248z$p = ".Entry-module_entries__6MOR- {\n  display: flex;\n  width: 100%;\n}\n\n.Entry-module_flexColumn__etp5N {\n  flex-direction: column;\n}\n.Entry-module_flexColumn__etp5N > div {\n  padding: 0.5rem 0rem;\n  border-bottom: 1px solid var(--cardBorder);\n}\n.Entry-module_flexColumn__etp5N > div:last-child {\n  border-bottom: 0;\n}\n\n.Entry-module_flexRow__Cu-zH {\n  flex-direction: row;\n}\n.Entry-module_flexRow__Cu-zH > div {\n  padding: 0rem 0.5rem;\n}\n.Entry-module_flexRow__Cu-zH > div:first-child {\n  border-left: 0;\n  padding-left: 0rem;\n}\n.Entry-module_flexRow__Cu-zH > div:last-child {\n  border-right: 0;\n  padding-right: 0rem;\n}\n\n.Entry-module_entry__XDout {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  column-gap: 2rem;\n  white-space: nowrap;\n}\n\n.Entry-module_entryFlexColumn__2frJl {\n  flex-direction: column;\n}\n\n.Entry-module_entryFlexRow__H2xCu {\n  flex-direction: row;\n}\n\n.Entry-module_bigEntry__xZQaY {\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.Entry-module_value__P25CQ {\n  white-space: nowrap;\n  font-feature-settings: \"tnum\" on, \"lnum\" on, \"zero\" on;\n  flex: 1;\n  display: flex;\n}\n\n.Entry-module_entryFlexRow__H2xCu .Entry-module_value__P25CQ {\n  justify-content: flex-end;\n}\n\n.Entry-module_children__YUp9- {\n  align-self: center;\n}\n\n.Entry-module_bigValue__KmTGs {\n  font-size: var(--v2-font-size-h3);\n  animation: Entry-module_fadeIn__U7ISB var(--animation-theme);\n}\n\n.Entry-module_alignSelfStart__RESyt {\n  align-self: start;\n}\n\n.Entry-module_alignSelfCenter__BAOzz {\n  align-self: center;\n}\n\n.Entry-module_alignSelfEnd__QVjnl {\n  align-self: end;\n}";
var o$3 = {"entries":"Entry-module_entries__6MOR-","flexColumn":"Entry-module_flexColumn__etp5N","flexRow":"Entry-module_flexRow__Cu-zH","entry":"Entry-module_entry__XDout","entryFlexColumn":"Entry-module_entryFlexColumn__2frJl","entryFlexRow":"Entry-module_entryFlexRow__H2xCu","bigEntry":"Entry-module_bigEntry__xZQaY","value":"Entry-module_value__P25CQ","children":"Entry-module_children__YUp9-","bigValue":"Entry-module_bigValue__KmTGs","fadeIn":"Entry-module_fadeIn__U7ISB","alignSelfStart":"Entry-module_alignSelfStart__RESyt","alignSelfCenter":"Entry-module_alignSelfCenter__BAOzz","alignSelfEnd":"Entry-module_alignSelfEnd__QVjnl"};
styleInject(css_248z$p);

const Entry = ({ label: t, value: s, big: a = !1, children: i, alignSelf: c = 'stretch', flex: m = 'row', width: o = 1 })=>jsxs("div", {
        style: {
            flex: o
        },
        className: s$6(o$3.entry, {
            [o$3.bigEntry]: a,
            [o$3.entryFlexRow]: 'row' === m,
            [o$3.entryFlexColumn]: 'column' === m,
            [o$3.alignSelfStart]: 'start' === c,
            [o$3.alignSelfCenter]: 'center' === c,
            [o$3.alignSelfEnd]: 'end' === c
        }),
        children: [
            t && jsx("div", {
                className: o$3.label,
                children: jsx("nbx-text", {
                    label: !0,
                    children: t
                })
            }),
            'string' == typeof s || 'number' == typeof s ? jsx("div", {
                className: s$6(o$3.value, {
                    [o$3.bigValue]: a
                }),
                children: null != s ? s : ''
            }) : s,
            i && jsx("div", {
                className: s$6(o$3.value, o$3.children, {
                    [o$3.bigValue]: a
                }),
                children: i
            })
        ]
    });

const Entries = ({ children: e, flex: m = 'row' })=>jsx("div", {
        className: s$6(o$3.entries, {
            [o$3.flexRow]: 'row' === m,
            [o$3.flexColumn]: 'column' === m
        }),
        children: e
    });

const ModalPane = ({ onConfirm: l, onCancel: r, onClose: c, children: a, heading: i, modalPortalRef: m })=>{
    let { t: d } = useTranslation();
    return (null == m ? void 0 : m.current) && createPortal(jsxs("nbx-modal-container", {
        open: !0,
        "aria-label": `modal-pane-${i}`,
        children: [
            jsx("nbx-modal-overlay", {
                slot: "overlay",
                onClick: r || c
            }),
            jsxs("nbx-modal-pane", {
                slot: "modal",
                heading: i,
                children: [
                    a,
                    r && jsx("nbx-button", {
                        slot: "left-button",
                        onClick: r,
                        children: d('common_cancel')
                    }),
                    c && jsx("nbx-button", {
                        slot: "center-button",
                        onClick: c,
                        children: d('common_close')
                    }),
                    l && jsx("nbx-button", {
                        slot: "right-button",
                        onClick: l,
                        inverted: !0,
                        children: d('common_confirm')
                    })
                ]
            })
        ]
    }), m.current);
};

var css_248z$o = ".Box-module_box__Wv1pf {\n  padding: 1rem;\n  border-radius: var(--v2-card-border-radius);\n  border-width: 0;\n}\n@media (max-width: 899px) {\n  .Box-module_box__Wv1pf {\n    padding: 0.6rem;\n  }\n}\n\n.Box-module_bordered__QWDP- {\n  border: var(--v2-card-border-width) solid var(--v2-border-color);\n}\n\n.Box-module_flexBoxRow__oNVfP {\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  width: 100%;\n}\n\n.Box-module_flexBoxColumn__Nsu0R {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  height: 100%;\n  justify-content: space-evenly;\n}\n\n.Box-module_justifyContentCenter__RD3hH {\n  justify-content: center;\n}\n\n.Box-module_justifyContentSpaceBetween__IdKC5 {\n  justify-content: space-between;\n}\n\n.Box-module_alignItemsCenter__6wwjO {\n  align-items: center;\n}\n\n.Box-module_bg__7EgTD {\n  background-color: var(--color-grey-lighter);\n}";
var o$2 = {"box":"Box-module_box__Wv1pf","bordered":"Box-module_bordered__QWDP-","flexBoxRow":"Box-module_flexBoxRow__oNVfP","flexBoxColumn":"Box-module_flexBoxColumn__Nsu0R","justifyContentCenter":"Box-module_justifyContentCenter__RD3hH","justifyContentSpaceBetween":"Box-module_justifyContentSpaceBetween__IdKC5","alignItemsCenter":"Box-module_alignItemsCenter__6wwjO","bg":"Box-module_bg__7EgTD"};
styleInject(css_248z$o);

const Box = ({ children: s, ariaLabel: r, bordered: a = !0, title: l, className: i, flexDirection: c, justifyContent: m, alignItems: x, bg: d = !1 })=>jsxs("div", {
        "aria-label": r,
        className: s$6(o$2.box, i, {
            [o$2.bordered]: a,
            [o$2.flexBoxRow]: 'row' === c,
            [o$2.flexBoxColumn]: 'column' === c,
            [o$2.alignItemsCenter]: 'center' === x,
            [o$2.justifyContentCenter]: 'center' === m,
            [o$2.justifyContentSpaceBetween]: 'space-between' === m,
            [o$2.bg]: d
        }),
        children: [
            l && jsx("div", {
                className: o$2.tableTitle,
                children: jsx("nbx-heading", {
                    tag: "h4",
                    children: l
                })
            }),
            s
        ]
    });

var css_248z$n = ".Text-module_message__XvUnT {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n}\n\n.Text-module_center__tNTJk {\n  justify-content: center;\n  align-items: center;\n}\n\n.Text-module_border__DDG6e {\n  border: 1px solid var(--v2-card-border-color);\n  border-radius: var(--v2-card-border-radius);\n}\n\n.Text-module_nowrap__RcgQg {\n  white-space: nowrap;\n}";
var t$4 = {"message":"Text-module_message__XvUnT","center":"Text-module_center__tNTJk","border":"Text-module_border__DDG6e","nowrap":"Text-module_nowrap__RcgQg"};
styleInject(css_248z$n);

const Text = ({ text: a, children: m, center: o = !0, border: l = !1, ariaLabel: n, nowrap: x = !1 })=>jsxs("div", {
        className: s$6(t$4.message, {
            [t$4.center]: o,
            [t$4.border]: l,
            [t$4.nowrap]: x
        }),
        "aria-label": null != n ? n : 'text',
        children: [
            a && jsx("nbx-text", {
                children: a
            }),
            m
        ]
    });

var css_248z$m = ".Table-module_table__-ZPCW {\n  width: 100%;\n  position: relative;\n  font-size: var(--v2-font-size-body);\n  display: flex;\n  flex-direction: column;\n  font-feature-settings: \"tnum\" on, \"lnum\" on, \"zero\" on;\n  font-size: 0.9em;\n}\n@media (min-width: 900px) and (max-width: 1366px) {\n  .Table-module_table__-ZPCW {\n    font-size: 0.8em;\n  }\n}\n@media (max-width: 899px) {\n  .Table-module_table__-ZPCW {\n    font-size: 0.8em;\n  }\n}\n\n.Table-module_bordered__0FmPK {\n  border: 2px solid var(--v2-border-color);\n  border-radius: var(--v2-card-border-radius);\n  border-width: var(--v2-card-border-width);\n}\n\n.Table-module_data__Hq24F {\n  display: grid;\n}\n\n.Table-module_tableTitle__KdHEp {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 10px 15px 10px 25px;\n  transition: border-color var(--animation-theme);\n}\n\n.Table-module_borderedTitle__BuU-l {\n  border-bottom: var(--v2-card-border-width) solid var(--v2-card-border-color);\n}\n\n.Table-module_tableHead__KdeWe {\n  color: var(--color-grey-dark);\n  text-transform: none;\n  white-space: normal;\n  word-break: normal;\n  transition: color var(--animation-theme);\n  padding: 1rem 0rem;\n  font-weight: var(--font-weight-regular);\n}\n\n.Table-module_tableHeadBordered__LHtW8 {\n  border-bottom: 2px solid var(--v2-border-color);\n}\n\n.Table-module_rowContents__FhRsM {\n  display: contents;\n}\n\n.Table-module_rowExpandable__TK-P1 {\n  display: none;\n}\n\n.Table-module_rowExpanded__DlCcj {\n  display: contents;\n}\n\n.Table-module_tableCellWrap__5cxtH {\n  display: flex;\n  align-items: center;\n  padding: 0.4rem;\n}\n@media (min-width: 900px) and (max-width: 1366px) {\n  .Table-module_tableCellWrap__5cxtH {\n    margin: 0;\n  }\n}\n@media (max-width: 899px) {\n  .Table-module_tableCellWrap__5cxtH {\n    margin: 0;\n  }\n}\n\n.Table-module_rowHover__EiX8s:hover .Table-module_tableCellWrap__5cxtH {\n  background: var(--v2-button-bg-hover);\n}\n\n.Table-module_rowHoverCursor__-sYTz:hover .Table-module_tableCellWrap__5cxtH {\n  cursor: pointer;\n}\n\n.Table-module_rowPadding__uIL8A {\n  padding: 1rem 0.4rem;\n}\n\n.Table-module_rowBordered__Zgfog {\n  border-bottom: 1px solid var(--cardBorder);\n}\n\n.Table-module_rowDataBordered__TWjvZ {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n@media (max-width: 899px) {\n  .Table-module_rowDataBordered__TWjvZ {\n    padding-left: 0.2rem;\n    padding-right: 0.2rem;\n  }\n}\n\n.Table-module_tableCell__ufCx1 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.Table-module_label__6nz00 {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  height: 32px;\n  padding: 2px 14px 0;\n  border-radius: 14px;\n  font-size: var(--v2-font-size-button);\n  line-height: 100%;\n  color: var(--color-charcoal);\n}\n@media (max-width: 899px) {\n  .Table-module_label__6nz00 {\n    height: 22px;\n    padding: 2px 8px 0;\n    border-radius: 8px;\n  }\n}\n\n.Table-module_labelCompact__lE7no {\n  height: 28px;\n  padding: 2px 10px 0;\n  border-radius: 10px;\n}\n\n.Table-module_caption__7Zxs6 {\n  padding-top: 8rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 4rem;\n}\n@media (min-width: 900px) and (max-width: 1366px) {\n  .Table-module_caption__7Zxs6 {\n    padding-top: 2rem;\n    scale: 0.9;\n  }\n}\n@media (max-width: 899px) {\n  .Table-module_caption__7Zxs6 {\n    padding-top: 2rem;\n    scale: 0.8;\n  }\n}\n\n.Table-module_footer__IMgHo {\n  padding: 1.2rem;\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n}";
var i$1 = {"table":"Table-module_table__-ZPCW","bordered":"Table-module_bordered__0FmPK","data":"Table-module_data__Hq24F","tableTitle":"Table-module_tableTitle__KdHEp","borderedTitle":"Table-module_borderedTitle__BuU-l","tableHead":"Table-module_tableHead__KdeWe","tableHeadBordered":"Table-module_tableHeadBordered__LHtW8","rowContents":"Table-module_rowContents__FhRsM","rowExpandable":"Table-module_rowExpandable__TK-P1","rowExpanded":"Table-module_rowExpanded__DlCcj","tableCellWrap":"Table-module_tableCellWrap__5cxtH","rowHover":"Table-module_rowHover__EiX8s","rowHoverCursor":"Table-module_rowHoverCursor__-sYTz","rowPadding":"Table-module_rowPadding__uIL8A","rowBordered":"Table-module_rowBordered__Zgfog","rowDataBordered":"Table-module_rowDataBordered__TWjvZ","tableCell":"Table-module_tableCell__ufCx1","label":"Table-module_label__6nz00","labelCompact":"Table-module_labelCompact__lE7no","caption":"Table-module_caption__7Zxs6","footer":"Table-module_footer__IMgHo"};
styleInject(css_248z$m);

const Caption = ({ message: o, onClick: a, isLoading: c = !1, isCompact: s = !1 })=>{
    let { t: l } = useTranslation();
    return jsxs("div", {
        className: i$1.caption,
        children: [
            c && jsx("nbx-spinner", {}),
            !c && jsxs(Fragment, {
                children: [
                    !s && jsx("nbx-blob", {
                        width: '8rem'
                    }),
                    jsx("div", {
                        children: jsx("nbx-heading", {
                            tag: s ? 'h5' : 'h3',
                            children: null != o ? o : l('error_title_generic')
                        })
                    }),
                    !!a && jsx("nbx-button", {
                        onClick: a,
                        icon: "refresh",
                        children: l('common_try_again')
                    })
                ]
            })
        ]
    });
};

const Cell = (o)=>{
    var a, m;
    let r = null === (a = o.column.colorMap) || void 0 === a ? void 0 : a.get(o.cellData);
    return jsx("div", {
        className: s$6(i$1.tableCell, {
            [i$1.label]: !!r,
            [i$1.labelCompact]: o.isCompact && !!r
        }),
        style: {
            justifyContent: o.column.justify,
            textAlign: null !== (m = o.column.justify) && void 0 !== m ? m : 'center',
            backgroundColor: o.column.template ? void 0 : r
        },
        children: (({ column: t, rowData: l, isExpanded: e })=>{
            let o = l[t.key];
            return t.template ? t.template({
                column: t,
                rowData: l,
                isExpanded: e,
                cellData: o
            }) : t.format ? t.format && t.format(o) : o;
        })(o)
    });
};

const Row = ({ data: t, columns: n, isExpanded: d = !1, isExpandable: i = !0, renderDetails: m, onExpand: c, onCollapse: w, bordered: p, isCompact: u })=>jsxs(Fragment, {
        children: [
            jsx("div", {
                className: s$6(i$1.rowContents, {
                    [i$1.rowHover]: !d,
                    [i$1.rowHoverCursor]: i && m && !d
                }),
                onClick: ()=>{
                    i && (d ? w && w() : c && c());
                },
                "aria-label": "tableRow",
                children: n.map((r)=>{
                    var o, n;
                    return jsx("div", {
                        className: s$6(i$1.tableCellWrap, {
                            [i$1.rowBordered]: !u && !d,
                            [i$1.rowDataBordered]: p,
                            [i$1.rowPadding]: !u
                        }),
                        style: {
                            justifyContent: null !== (o = r.justify) && void 0 !== o ? o : 'center',
                            textAlign: null !== (n = r.justify) && void 0 !== n ? n : 'center'
                        },
                        children: jsx(Cell, {
                            column: r,
                            rowData: t,
                            cellData: t[r.key],
                            isExpanded: d,
                            isCompact: u
                        }, r.key)
                    }, r.key);
                })
            }),
            i && jsx("div", {
                className: s$6(i$1.rowExpandable, i$1.rowContents, {
                    [i$1.rowExpanded]: d
                }),
                children: jsx("div", {
                    className: s$6({
                        [i$1.rowBordered]: !u
                    }),
                    style: {
                        gridColumn: `span ${n.length}`
                    },
                    children: d && m && m(t)
                })
            })
        ]
    });

const TBody = ({ data: l, columns: a, renderRowDetails: s, isLoading: d, isError: m, onError: c, msgNoData: p, msgError: h, bordered: g, isCompact: C, hasMoreData: x = !1 })=>{
    let [b, u] = useState(0);
    return m ? jsx(t$3, {
        length: a.length,
        children: jsx(Caption, {
            message: h,
            isError: m,
            onClick: c,
            isCompact: C
        })
    }) : d ? jsx(t$3, {
        length: a.length,
        children: jsx(Caption, {
            isLoading: d,
            isCompact: C
        })
    }) : x || l && 0 !== l.length ? jsx("div", {
        className: i$1.rowContents,
        "aria-label": "tableBody",
        children: null == l ? void 0 : l.map((o, i)=>jsx(Row, {
                data: o,
                columns: a,
                renderDetails: s,
                isExpanded: b === i,
                isExpandable: o.isExpandable,
                onExpand: ()=>u(i),
                bordered: g,
                isCompact: C
            }, o.id))
    }) : jsx(t$3, {
        length: a.length,
        children: jsx(Caption, {
            message: p || '',
            onClick: c,
            isCompact: C
        })
    });
};
let t$3 = ({ length: o, children: i })=>jsx("div", {
        style: {
            gridColumn: `span ${o}`
        },
        children: i
    });

var css_248z$l = ".Heading-module_h4heading__zq47I {\n  font-feature-settings: \"tnum\";\n  margin: 0;\n  color: var(--v2-text);\n  width: 100%;\n  line-height: 150%;\n  transition: color var(--animation-theme);\n  font-size: var(--v2-font-size-h4);\n  font-weight: var(--font-weight-medium);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-feature-settings: \"tnum\" on, \"lnum\" on, \"zero\" on;\n  opacity: 0.6;\n  text-align: center;\n}";
var s$5 = {"h4heading":"Heading-module_h4heading__zq47I"};
styleInject(css_248z$l);

const Heading = ({ children: r })=>jsx("h4", {
        className: s$5.h4heading,
        children: r
    });

const THead = ({ columns: l, bordered: s = !1 })=>jsx("div", {
        className: i$1.rowContents,
        "aria-label": "tableHead",
        children: l.map((l)=>jsx("div", {
                className: s$6(i$1.tableHead, i$1.tableCell, {
                    [i$1.tableHeadBordered]: s
                }),
                style: {
                    justifyContent: 'center'
                },
                children: jsx("div", {
                    children: jsx(Heading, {
                        children: l.header
                    })
                })
            }, l.key))
    });

const Table = ({ data: c, columns: b, renderRowDetails: h, isLoading: f, isError: u, onError: p, msgNoData: g, msgError: v, isShowHeader: x = !0, title: N, bordered: T = !1, ariaLabel: C, hasMoreData: j = !1, fetchMoreData: w, pageSize: D, isCompact: k = !1 })=>{
    var E;
    let [F, y] = useState(0), B = useIsMobile();
    useEffect(()=>{
        D && c && c.length <= D * (F + 1) && j && w && w();
    }, [
        c,
        w,
        j,
        F,
        D
    ]);
    let L = useMemo(()=>null == c ? void 0 : c.filter((e, l, r)=>r.findIndex((l)=>e.id === l.id) === l).slice(F * (null != D ? D : 0), (F + 1) * (null != D ? D : c.length)), [
        c,
        F,
        D
    ]), M = useMemo(()=>b.filter((e)=>!B || !e.hideOnMobile), [
        B
    ]);
    return jsxs("div", {
        className: s$6(i$1.table, {
            [i$1.bordered]: T
        }),
        "aria-label": null !== (E = null != C ? C : N) && void 0 !== E ? E : 'table',
        children: [
            N && jsx("div", {
                className: s$6(i$1.tableTitle, {
                    [i$1.borderedTitle]: T
                }),
                children: jsx("nbx-heading", {
                    tag: "h3",
                    margin: !1,
                    children: N
                })
            }),
            jsx("div", {
                className: i$1.filters,
                "aria-label": "tableFilters"
            }),
            jsxs("div", {
                className: i$1.data,
                "aria-label": "tableData",
                style: {
                    gridTemplateColumns: M.map((e)=>'auto' !== e.width && e.width ? `${e.width}fr` : 'auto').join(' ')
                },
                children: [
                    x && jsx(THead, {
                        columns: M,
                        bordered: T && !N
                    }),
                    jsx(TBody, {
                        data: L,
                        columns: M,
                        isLoading: f,
                        isError: u,
                        onError: p,
                        msgError: v,
                        msgNoData: g,
                        renderRowDetails: h,
                        bordered: T,
                        isCompact: k,
                        hasMoreData: j
                    })
                ]
            }),
            D && c && c.length > D && !u && jsxs("div", {
                className: i$1.footer,
                "aria-label": "tableFooter",
                children: [
                    jsx(Button, {
                        disabled: 0 === F,
                        onClick: ()=>y((e)=>e - 1),
                        children: "Prev"
                    }),
                    jsx(Button, {
                        disabled: c.length <= D * (F + 1),
                        onClick: ()=>y((e)=>e + 1),
                        children: "Next"
                    })
                ]
            }),
            !D && j && w && !u && jsx("div", {
                className: i$1.footer,
                "aria-label": "tableFooter",
                children: jsx(Button, {
                    onClick: ()=>w(),
                    children: "Load more"
                })
            })
        ]
    });
};

var css_248z$k = ".ButtonIcon-module_buttonIcon__hDYpn {\n  width: 36px;\n  border-radius: 50%;\n  padding: 5px 8px;\n  display: flex;\n  justify-content: center;\n  align-items: baseline;\n  opacity: 0.6;\n  cursor: pointer;\n}\n\n.ButtonIcon-module_buttonIcon__hDYpn:hover {\n  opacity: 1;\n  background: var(--v2-button-bg-hover);\n}\n\n.ButtonIcon-module_wrapIcon__pVJuB {\n  display: inline-block;\n  margin-top: 3px;\n}\n\n.ButtonIcon-module_hidden__sAWY4 {\n  visibility: hidden;\n}";
var o$1 = {"buttonIcon":"ButtonIcon-module_buttonIcon__hDYpn","wrapIcon":"ButtonIcon-module_wrapIcon__pVJuB","hidden":"ButtonIcon-module_hidden__sAWY4"};
styleInject(css_248z$k);

const ButtonIcon = ({ icon: s, onClick: c = ()=>{}, disabled: e = !1, hidden: i = !1, tooltip: r })=>jsx("span", {
        className: s$6(o$1.buttonIcon, {
            [o$1.hidden]: i
        }),
        children: jsx("nbx-button-text", {
            disabled: e,
            onClick: c,
            children: jsx("span", {
                className: o$1.wrapIcon,
                children: jsx("nbx-icon", {
                    icon: s,
                    tooltip: r
                })
            })
        })
    });

var css_248z$j = ".GridItems-module_gridItems__UnoUM {\n  display: grid;\n  padding: 10px;\n}\n\n.GridItems-module_gridItemsNoData__4wTI5 {\n  display: flex;\n  flex-direction: column;\n  gap: 3rem;\n  justify-content: center;\n  align-items: center;\n  padding-top: 100px;\n}\n\n@media (max-width: 575px) {\n  .GridItems-module_gridItems__UnoUM {\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap: 1rem;\n    padding: 10px 0;\n  }\n}\n@media (min-width: 576px) and (max-width: 899px) {\n  .GridItems-module_gridItems__UnoUM {\n    grid-template-columns: repeat(3, 1fr);\n    grid-gap: 1rem;\n  }\n}\n@media (min-width: 900px) and (max-width: 1200px) {\n  .GridItems-module_gridItems__UnoUM {\n    grid-template-columns: repeat(3, 1fr);\n    grid-gap: 1rem;\n  }\n}\n@media (min-width: 1201px) and (max-width: 1725px) {\n  .GridItems-module_gridItems__UnoUM {\n    grid-template-columns: repeat(4, 1fr);\n    grid-gap: 2rem;\n  }\n}\n@media (min-width: 1726px) {\n  .GridItems-module_gridItems__UnoUM {\n    grid-template-columns: repeat(5, 1fr);\n    grid-gap: 2rem;\n  }\n}\n.GridItems-module_footer__CI1ZK {\n  padding: 1.2rem;\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.GridItems-module_arrowButton__roljL {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.GridItems-module_arrow__xbEzU {\n  font-size: 1.2rem;\n}";
var n$6 = {"gridItems":"GridItems-module_gridItems__UnoUM","gridItemsNoData":"GridItems-module_gridItemsNoData__4wTI5","footer":"GridItems-module_footer__CI1ZK","arrowButton":"GridItems-module_arrowButton__roljL","arrow":"GridItems-module_arrow__xbEzU"};
styleInject(css_248z$j);

const GridItems = ({ data: s, renderCell: d, isLoading: c = !1, hasMoreData: m = !1, fetchMoreData: h, pageSize: p, renderEmpty: u })=>{
    let [N, b] = useState(0);
    useEffect(()=>{
        p && s && s.length <= p * (N + 1) && m && h && h();
    }, [
        s,
        h,
        m,
        N,
        p
    ]);
    let f = useMemo(()=>null == s ? void 0 : s.filter((e, l, r)=>r.findIndex((l)=>e.id === l.id) === l).slice(N * (null != p ? p : 0), (N + 1) * (null != p ? p : s.length)), [
        s,
        N,
        p
    ]);
    return c ? jsx(Loading, {}) : s && 0 !== s.length ? jsxs("div", {
        children: [
            jsx("div", {
                className: n$6.gridItems,
                children: null == f ? void 0 : f.map(d)
            }),
            p && s && s.length > p && jsxs("div", {
                className: n$6.footer,
                "aria-label": "tableFooter",
                children: [
                    jsx(Button, {
                        disabled: 0 === N,
                        onClick: ()=>b((e)=>e - 1),
                        children: jsxs("span", {
                            className: n$6.arrowButton,
                            children: [
                                jsx("span", {
                                    className: n$6.arrow,
                                    children: "\u2190"
                                }),
                                "Prev"
                            ]
                        })
                    }),
                    jsx(Button, {
                        disabled: s.length <= p * (N + 1),
                        onClick: ()=>b((e)=>e + 1),
                        children: jsxs("span", {
                            className: n$6.arrowButton,
                            children: [
                                "Next",
                                jsx("span", {
                                    className: n$6.arrow,
                                    children: "\u2192"
                                })
                            ]
                        })
                    })
                ]
            }),
            !p && m && h && jsx("div", {
                className: n$6.footer,
                "aria-label": "tableFooter",
                children: jsx(Button, {
                    onClick: ()=>h(),
                    children: "Load more"
                })
            })
        ]
    }) : jsxs("div", {
        className: n$6.gridItemsNoData,
        children: [
            jsx("nbx-blob", {
                width: '8rem'
            }),
            u && u()
        ]
    });
};

var css_248z$i = ".Line-module_line__a5So5 {\n  border-bottom: 1px solid var(--v2-spinner-inverted);\n}";
var e$2 = {"line":"Line-module_line__a5So5"};
styleInject(css_248z$i);

const Line = ()=>jsx("div", {
        className: e$2.line
    });

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */var r$3 = (s,{forceProperty:i=[],forceAttribute:o=[],forceEvent:c=[]}={forceProperty:[],forceAttribute:[],forceEvent:[]})=>{class u extends Component{constructor(e){super(e),this.eventHandlers=[],this.ref=this.props.innerRef||createRef();}setProperty(e,t){this.ref.current[e]=t;}setAttribute(e,t){if(!1===t)return this.ref.current.removeAttribute(e);this.ref.current.setAttribute(e,t.toString());}setEvent(e,t){this.eventHandlers.push([e,t]),this.ref.current.addEventListener(e,t);}update(){this.clearEventHandlers(),Object.entries(this.props).forEach(([e,t])=>{let r=!1;if(i.includes(e)&&(this.setProperty(e,t),r=!0),o.includes(e)&&(this.setAttribute(e,t),r=!0),c.includes(e)&&(this.setEvent(e,t),r=!0),!r&&"style"!==e&&"children"!==e){if("classname"===e.toLowerCase())return this.ref.current.className=t;if("string"==typeof t||"number"==typeof t||"boolean"==typeof t)return this.setProperty(e,t),void this.setAttribute(e,t);if("function"==typeof t){if(e.match(/^on[A-Z]/))return this.setEvent(e[2].toLowerCase()+e.substr(3),t);if(e.match(/^on\-[a-z]/))return this.setEvent(e.substr(3),t)}this.setProperty(e,t);}});}componentDidUpdate(){this.update();}componentDidMount(){this.update();}componentWillUnmount(){this.clearEventHandlers();}clearEventHandlers(){this.eventHandlers.forEach(([e,t])=>{this.ref.current.removeEventListener(e,t);}),this.eventHandlers=[];}render(){const{children:e,style:r}=this.props;return createElement(s,{ref:this.ref,style:r},e)}}return forwardRef((e,r)=>{var{children:n}=e,s=function(e,t){var r={};for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var s=0;for(n=Object.getOwnPropertySymbols(e);s<n.length;s++)t.indexOf(n[s])<0&&Object.prototype.propertyIsEnumerable.call(e,n[s])&&(r[n[s]]=e[n[s]]);}return r}(e,["children"]);return createElement(u,Object.assign({innerRef:r},s),n)})};

let t$2 = r$3('nbx-select');
const Select = (r)=>jsx(t$2, function(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {}, n = Object.keys(t);
            "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable;
            }))), n.forEach(function(r) {
                var n;
                n = t[r], r in e ? Object.defineProperty(e, r, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[r] = n;
            });
        }
        return e;
    }({
        bigfield: !1,
        error: '',
        hideerror: !0,
        hidelabel: !0,
        inputid: '',
        instanttrade: !1,
        label: '',
        margin: !0,
        muted: !1
    }, r));

var css_248z$h = ".ComingSoon-module_comingSoon__xpE9o {\n  position: relative;\n}\n\n.ComingSoon-module_comingSoonContent__9JJOm {\n  width: 100%;\n  height: 100;\n}\n.ComingSoon-module_comingSoonContent__9JJOm > * {\n  width: 100%;\n  height: 100;\n}\n\n.ComingSoon-module_comingSoonLabel__SFAB2 {\n  position: absolute;\n  top: 0;\n  right: 0;\n  border-bottom-left-radius: 4px;\n  padding: 4px;\n  font-size: 12px;\n  color: var(--color-white);\n  background-color: var(--color-blue);\n}";
var s$4 = {"comingSoon":"ComingSoon-module_comingSoon__xpE9o","comingSoonContent":"ComingSoon-module_comingSoonContent__9JJOm","comingSoonLabel":"ComingSoon-module_comingSoonLabel__SFAB2"};
styleInject(css_248z$h);

const ComingSoon = ({ children: i })=>i ? jsxs("div", {
        className: s$4.comingSoon,
        children: [
            jsx("span", {
                className: s$4.comingSoonLabel,
                children: "ComingSoon"
            }),
            jsx("div", {
                className: s$4.comingSoonContent,
                children: i
            })
        ]
    }) : jsx(Message, {
        text: "Coming soon! Watch this space.",
        border: !0,
        children: "\u{1F440}"
    });

var css_248z$g = ".Accordion-module_accordion__wD27Q {\n  width: 100%;\n  overflow: hidden;\n  background: var(--background);\n  transition: border var(--animation-theme), background-color var(--animation-theme);\n}\n\n.Accordion-module_bordered__PfF4R {\n  border-radius: var(--form-field-border-radius);\n  border: var(--v2-border-width) solid var(--v2-input-border);\n}\n\n.Accordion-module_toggle__ihla7 {\n  border: none;\n  background: transparent;\n  outline: none;\n  cursor: pointer;\n  height: var(--form-option-height);\n  width: 100%;\n  padding: 0 16px;\n  transition: background var(--animation-theme);\n}\n.Accordion-module_toggle__ihla7:hover {\n  background: var(--v2-button-bg-hover);\n}\n\n.Accordion-module_toggleRow__p-KZr {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: var(--v2-text);\n  font-weight: 600;\n}\n\n.Accordion-module_chevron__eGTIP {\n  transform-origin: center;\n}\n\n.Accordion-module_flipped__dRRkF {\n  transform: rotate(180deg);\n}\n\n.Accordion-module_contentWrap__Bgzao {\n  width: 100%;\n  transition: height var(--animation-fast);\n}\n\n.Accordion-module_content__RyBzl {\n  padding: 10px;\n}";
var r$2 = {"accordion":"Accordion-module_accordion__wD27Q","bordered":"Accordion-module_bordered__PfF4R","toggle":"Accordion-module_toggle__ihla7","toggleRow":"Accordion-module_toggleRow__p-KZr","chevron":"Accordion-module_chevron__eGTIP","flipped":"Accordion-module_flipped__dRRkF","contentWrap":"Accordion-module_contentWrap__Bgzao","content":"Accordion-module_content__RyBzl"};
styleInject(css_248z$g);

const Accordion = ({ label: c, bordered: a = !0, expanded: d = !1, children: m })=>{
    let [v, f] = useState(d), [h, p] = useState(!1), [u, g] = useState(), [w, x] = useState(null), N = useCallback(()=>{
        g(null == w ? void 0 : w.offsetHeight);
    }, [
        null == w ? void 0 : w.offsetHeight
    ]);
    useEffect(()=>(window.addEventListener('resize', N, {
            passive: !0,
            capture: !0
        }), ()=>window.removeEventListener('resize', N)), [
        N
    ]), useEffect(()=>{
        h || v || p(!0);
    }, [
        v,
        h
    ]), useLayoutEffect(()=>N(), [
        null == w ? void 0 : w.offsetHeight,
        N,
        m
    ]);
    let b = d && !h ? {} : {
        height: v ? `${(null != u ? u : 0) + 20}px` : 0
    };
    return jsxs("div", {
        className: s$6(r$2.accordion, {
            [r$2.bordered]: a
        }),
        "aria-label": `Accordion${c}`,
        children: [
            jsx("button", {
                className: r$2.toggle,
                type: "button",
                onClick: ()=>{
                    N(), f((e)=>!e);
                },
                children: jsxs("div", {
                    className: r$2.toggleRow,
                    children: [
                        c,
                        jsx("div", {
                            className: s$6(r$2.chevron, {
                                [r$2.flipped]: v
                            }),
                            children: jsx("nbx-icon", {
                                icon: "arrowdown"
                            })
                        })
                    ]
                })
            }),
            jsx("div", {
                className: r$2.contentWrap,
                style: b,
                children: jsx("div", {
                    ref: x,
                    className: r$2.content,
                    children: m
                })
            })
        ]
    });
};

var css_248z$f = "@keyframes ScrollableHorizontalNav-module_fadeIn__e-ThJ {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes ScrollableHorizontalNav-module_fadeOut__niLsR {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n@keyframes ScrollableHorizontalNav-module_blinker__M9Tg- {\n  50% {\n    opacity: 0.2;\n  }\n}\n.ScrollableHorizontalNav-module_scrollableHorizontalNav__2-fxZ {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n@media (max-width: 480px) {\n  .ScrollableHorizontalNav-module_scrollableHorizontalNav__2-fxZ {\n    max-width: calc(var(--base-max-page-width) - 2 * var(--viewport-padding));\n    white-space: nowrap;\n    overflow-x: auto;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    gap: 0.6rem;\n    flex-wrap: nowrap;\n    overflow-y: hidden;\n  }\n  .ScrollableHorizontalNav-module_scrollableHorizontalNav__2-fxZ::-webkit-scrollbar {\n    display: none;\n  }\n}";
var a = {"scrollableHorizontalNav":"ScrollableHorizontalNav-module_scrollableHorizontalNav__2-fxZ","fadeIn":"ScrollableHorizontalNav-module_fadeIn__e-ThJ","fadeOut":"ScrollableHorizontalNav-module_fadeOut__niLsR","blinker":"ScrollableHorizontalNav-module_blinker__M9Tg-"};
styleInject(css_248z$f);

const ScrollableHorizontalNav = ({ children: o, ariaLabel: r })=>jsx("div", {
        className: a.scrollableHorizontalNav,
        "aria-label": `ScrollableHorizontalNav${r}`,
        children: o
    });

var css_248z$e = ".NumberField-module_numberField__AjZ9N {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.NumberField-module_inputs__ycYJf {\n  display: flex;\n  align-items: center;\n}\n.NumberField-module_inputs__ycYJf > button {\n  display: inline-block;\n  cursor: pointer;\n  outline: none;\n  position: relative;\n  font-family: inherit;\n  font-size: 1.4rem;\n  font-weight: var(--font-weight-bold);\n  letter-spacing: 0.01em;\n  padding: 0.2rem 1rem;\n  height: var(--form-input-height);\n  margin: 0;\n  background: var(--v2-button-bg);\n  color: var(--v2-text);\n  width: auto;\n  transition: color var(--animation-theme), background var(--animation-theme), border-color var(--animation-theme), opacity var(--animation-theme);\n}\n.NumberField-module_inputs__ycYJf > button:hover {\n  background: var(--v2-button-bg-hover);\n}\n\n.NumberField-module_buttonLeft__yj8S- {\n  border: var(--v2-border-width) solid var(--v2-input-border);\n  border-right: 0;\n  border-top-left-radius: calc(var(--form-input-height) / 2);\n  border-bottom-left-radius: calc(var(--form-input-height) / 2);\n}\n\n.NumberField-module_buttonRight__2SNst {\n  border: var(--v2-border-width) solid var(--v2-input-border);\n  border-left: 0;\n  border-bottom-right-radius: calc(var(--form-input-height) / 2);\n  border-top-right-radius: calc(var(--form-input-height) / 2);\n}";
var t$1 = {"numberField":"NumberField-module_numberField__AjZ9N","inputs":"NumberField-module_inputs__ycYJf","buttonLeft":"NumberField-module_buttonLeft__yj8S-","buttonRight":"NumberField-module_buttonRight__2SNst"};
styleInject(css_248z$e);

var e$1;
var NUMBER_FIELD_INPUT_ERRORS = ((e$1 = {})[e$1.greaterThanMaximum = 1] = "greaterThanMaximum", e$1[e$1.lowerThanMinimum = 2] = "lowerThanMinimum", e$1[e$1.invalidValue = 3] = "invalidValue", e$1);
const NumberField = ({ value: e, onChange: u, onError: m, label: o, min: s = 0, max: c, step: d = 1, maxLength: b = 30 })=>{
    let h = useRef(null), v = useCallback((e)=>{
        e < s && m(2), c && e > c && m(1);
    }, [
        c,
        s,
        m
    ]), x = useCallback((e)=>{
        if (e.value.length <= b && e.validity.valid) {
            let r = +e.value;
            u(r), v(r);
        } else m(3);
    }, [
        b,
        u,
        m,
        v
    ]), f = useCallback(()=>{
        if (!h.current) return;
        let e = +h.current.value;
        e <= s || (u(e - d), v(e - d));
    }, [
        s,
        u,
        d,
        v
    ]), g = useCallback(()=>{
        if (!h.current) return;
        let e = +h.current.value;
        u(e + d), v(e + d);
    }, [
        u,
        d,
        v
    ]);
    return jsxs("div", {
        className: t$1.numberField,
        children: [
            jsx("div", {
                className: t$1.label,
                children: jsx("nbx-text", {
                    label: !0,
                    children: jsx("label", {
                        htmlFor: 'numberField',
                        className: t$1.fieldLabel,
                        children: o
                    })
                })
            }),
            jsxs("div", {
                className: t$1.inputs,
                children: [
                    jsx("button", {
                        className: t$1.buttonLeft,
                        onClick: f,
                        children: "-"
                    }),
                    jsx(Field, {
                        ref: h,
                        id: "numberField",
                        label: `numberField${o}`,
                        isShowLabel: !1,
                        type: "number",
                        value: e.toString(),
                        onChange: (e)=>x(e.currentTarget),
                        onBlur: (e)=>x(e.currentTarget),
                        textAlign: "center",
                        noErrorLabel: !0,
                        isBorderRadius: !1,
                        maxLength: b
                    }),
                    jsx("button", {
                        className: t$1.buttonRight,
                        onClick: g,
                        children: "+"
                    })
                ]
            })
        ]
    });
};

var css_248z$d = ".StepBar-module_stepBar__KMMpY {\n  display: flex;\n  justify-content: stretch;\n  border: 1px solid var(--v2-border-color);\n  height: 0.5rem;\n  margin: 1rem;\n}\n.StepBar-module_stepBar__KMMpY > * {\n  flex: 1;\n}\n\n.StepBar-module_done__zaI6J {\n  background-color: var(--v2-border-color);\n}";
var r$1 = {"stepBar":"StepBar-module_stepBar__KMMpY","done":"StepBar-module_done__zaI6J"};
styleInject(css_248z$d);

const StepBar = ({ current: e, total: m })=>jsx("div", {
        className: r$1.stepBar,
        "aria-label": "stepBar",
        children: [
            ...Array(m).keys()
        ].map((m)=>jsx("div", {
                className: s$6({
                    [r$1.done]: m < e
                })
            }, m))
    });

var css_248z$c = ".RangeSlider-module_rangeSlider__n31o- {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.RangeSlider-module_fields__dgV8N {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n.RangeSlider-module_fields__dgV8N > * {\n  flex: 1;\n}\n\ninput[type=range] {\n  -webkit-appearance: none;\n  height: 7px;\n  background: grey;\n  border-radius: 5px;\n  background-image: linear-gradient(#0668e1, #0668e1);\n  background-repeat: no-repeat;\n}\n\ninput[type=range]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  background: #0668e1;\n  cursor: pointer;\n  box-shadow: 0 0 2px 0 #555;\n}\n\ninput[type=range]::-webkit-slider-runnable-track {\n  -webkit-appearance: none;\n  box-shadow: none;\n  border: none;\n  background: transparent;\n}";
var l$1 = {"rangeSlider":"RangeSlider-module_rangeSlider__n31o-","fields":"RangeSlider-module_fields__dgV8N"};
styleInject(css_248z$c);

const RangeSlider = ({ label: r, left: i, right: m, min: s, max: d, labelLeft: o, labelRight: u, onChange: g, isShowLabel: p = !0, isShowSlider: v = !0 })=>{
    let c = useCallback((e)=>{
        g('' !== e.target.value ? e.target.value : void 0, m);
    }, [
        g,
        m
    ]), x = useCallback((e)=>{
        g(i, '' !== e.target.value ? e.target.value : void 0);
    }, [
        i,
        g
    ]);
    return jsxs("div", {
        className: l$1.rangeSlider,
        children: [
            p && jsx("nbx-text", {
                children: r
            }),
            v && jsxs("div", {
                className: l$1.inputs,
                children: [
                    jsx("input", {
                        type: "range",
                        value: i,
                        min: s,
                        max: d,
                        step: 1,
                        onChange: c
                    }),
                    jsx("input", {
                        type: "range",
                        value: m,
                        min: s,
                        max: d,
                        step: 1,
                        onChange: x
                    })
                ]
            }),
            jsxs("div", {
                className: l$1.fields,
                children: [
                    jsx(Field, {
                        id: 'labelLeft',
                        label: o,
                        type: "number",
                        value: i,
                        onChange: c,
                        min: s,
                        max: d
                    }),
                    jsx(Field, {
                        id: 'labelRight',
                        label: u,
                        type: "number",
                        value: m,
                        onChange: x,
                        min: s,
                        max: d
                    })
                ]
            })
        ]
    });
};

var css_248z$b = ".MsgDone-module_msgDone__orwZa,\n.MsgDone-module_content__-ME-1 {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  text-align: center;\n}";
var n$5 = {"msgDone":"MsgDone-module_msgDone__orwZa","content":"MsgDone-module_content__-ME-1"};
styleInject(css_248z$b);

const MsgDone = ({ children: m, onClose: t, closeLabel: c })=>{
    let { t: i } = useTranslation();
    return jsxs("div", {
        className: n$5.msgDone,
        "aria-label": "msgDone",
        children: [
            jsxs("nbx-text", {
                children: [
                    i('common_done'),
                    "!"
                ]
            }),
            jsx("nbx-icon", {
                icon: "verify"
            }),
            jsx("div", {
                className: n$5.content,
                children: m
            }),
            t && jsx(Button, {
                onClick: t,
                children: null != c ? c : i('common_close')
            })
        ]
    });
};

var css_248z$a = ".MsgError-module_msgError__uc5PB,\n.MsgError-module_content__tG0Jn {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  text-align: center;\n}";
var n$4 = {"msgError":"MsgError-module_msgError__uc5PB","content":"MsgError-module_content__tG0Jn"};
styleInject(css_248z$a);

const MsgError = ({ children: c, error: i, reset: l, msg: a, showContactSupport: x, showTryAgain: d })=>{
    let { t: h } = useTranslation();
    return useEffect(()=>{
        i && console.error(i);
    }, [
        i
    ]), jsxs("div", {
        className: n$4.msgError,
        "aria-label": "msgError",
        children: [
            jsx("nbx-blob", {
                width: '6rem'
            }),
            a || c ? jsxs(Fragment, {
                children: [
                    a && jsx("nbx-text", {
                        children: a
                    }),
                    c && jsx("div", {
                        className: n$4.content,
                        children: c
                    })
                ]
            }) : jsx("nbx-text", {
                children: null != a ? a : h('error_title_generic')
            }),
            l && jsx(Button, {
                onClick: l,
                children: h(d ? 'common_try_again' : 'common_close')
            }),
            x && jsx("nbx-button-text", {
                href: "https://nbxsupport.zendesk.com/hc/en-us/requests/new",
                children: h('common_support')
            })
        ]
    });
};

var css_248z$9 = ".AppError-module_appError__MEc-Y {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 3rem;\n}";
var n$3 = {"appError":"AppError-module_appError__MEc-Y"};
styleInject(css_248z$9);

const AppError = ({ error: s, clearError: i })=>{
    let { t: m } = useTranslation();
    return useEffect(()=>{
        s && console.error(s);
    }, [
        s
    ]), jsxs("div", {
        className: n$3.appError,
        children: [
            jsx("nbx-text", {
                tag: "h3",
                children: m('error_title_generic')
            }),
            jsx("nbx-text", {
                tag: "p",
                muted: !0,
                children: m('error_message_snag')
            }),
            i ? jsx("nbx-button", {
                target: "_self",
                onClick: i,
                children: m('common_try_again')
            }) : jsx("nbx-blob", {
                width: '8rem'
            })
        ]
    });
};

var css_248z$8 = "@keyframes FadeInContainer-module_fadeIn__Xc-yl {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes FadeInContainer-module_fadeOut__QrRck {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n@keyframes FadeInContainer-module_blinker__eLco3 {\n  50% {\n    opacity: 0.2;\n  }\n}\n.FadeInContainer-module_fadeIn__Xc-yl {\n  display: inline-block;\n  animation: FadeInContainer-module_fadeIn__Xc-yl var(--animation-theme);\n}";
var n$2 = {"fadeIn":"FadeInContainer-module_fadeIn__Xc-yl","fadeOut":"FadeInContainer-module_fadeOut__QrRck","blinker":"FadeInContainer-module_blinker__eLco3"};
styleInject(css_248z$8);

const FadeInContainer = ({ children: r })=>jsx("div", {
        className: n$2.fadeIn,
        children: r
    });

var css_248z$7 = ".BiometricGate-module_container__J7zrh {\n  background: var(--background);\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 999999;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 90px;\n}\n\n.BiometricGate-module_invertColor__94SzY {\n  filter: invert(100%);\n}\n\n.BiometricGate-module_logo__RD1bF {\n  width: 150px;\n}\n\n.BiometricGate-module_fingerprint__oIP8c {\n  width: 125px;\n}\n\n.BiometricGate-module_error__V2Dbo {\n  font-size: var(--font-size-body);\n  color: var(--color-red);\n  margin-bottom: 20px;\n}";
var c = {"container":"BiometricGate-module_container__J7zrh","invertColor":"BiometricGate-module_invertColor__94SzY","logo":"BiometricGate-module_logo__RD1bF","fingerprint":"BiometricGate-module_fingerprint__oIP8c","error":"BiometricGate-module_error__V2Dbo"};
styleInject(css_248z$7);

const BiometricGate = ({ onRequestBiometricAuth: a, loading: l, error: g, requestOnInit: p = !0, tag: d })=>{
    let f = (...r)=>console.log(`<BiometricGate>: [${d}]`, ...r), u = useTheme(), h = {
        [c.invertColor]: 'dark' === u
    }, { t: x } = useTranslation();
    return useEffect(()=>(f("mount"), ()=>f("dismount")), []), useEffect(()=>{
        p && (f(`requestOnInit=${p} onRequestBiometricAuth()`), a());
    }, [
        p
    ]), jsxs("div", {
        className: c.container,
        children: [
            jsx("img", {
                src: "/assets/icons/logo_nbx.svg",
                alt: "Logo",
                className: s$6([
                    c.logo,
                    h
                ])
            }),
            jsx("img", {
                src: "/assets/icons/fingerprint.svg",
                alt: "Fingerprint",
                className: s$6([
                    c.fingerprint,
                    h
                ])
            }),
            jsxs("div", {
                children: [
                    g && jsx("div", {
                        className: c.error,
                        children: x('common_try_again')
                    }),
                    l ? jsx(Loading, {}) : jsx(Button, {
                        onClick: a,
                        children: x('common_authenticate')
                    })
                ]
            })
        ]
    });
};

var css_248z$6 = ".styles-module_addToAppleWallet__7O4es {\n  height: calc(var(--button-height) + 10px);\n}\n\n.styles-module_logo__ilrP1 {\n  height: 80px;\n}\n\n.styles-module_wrapper__CuBTZ {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: max(40px, 20px, (var(--button-height) + 10px) * 0.1);\n  margin: 0 20px;\n}\n\n@media only screen and (max-width: 400px) {\n  .styles-module_wrapper__CuBTZ {\n    gap: max(25px, 20px, (var(--button-height) + 10px) * 0.1);\n  }\n}\n.styles-module_banner__jERXG {\n  border: var(--v2-card-border-width) solid var(--v2-card-border-color);\n  border-radius: var(--v2-card-border-radius);\n  background-color: white;\n  color: black;\n  padding: 20px;\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n.styles-module_banner__jERXG p {\n  margin: 0;\n}";
var s$3 = {"addToAppleWallet":"styles-module_addToAppleWallet__7O4es","logo":"styles-module_logo__ilrP1","wrapper":"styles-module_wrapper__CuBTZ","banner":"styles-module_banner__jERXG"};
styleInject(css_248z$6);

const AddToAppleWallet = ({ onClick: o })=>{
    let s = useLang();
    return jsx("div", {
        onClick: ()=>o(),
        onKeyDown: ()=>o(),
        role: "button",
        tabIndex: 0,
        children: jsx("img", {
            className: s$3.addToAppleWallet,
            src: `/assets/apple-pay/add-to-apple-wallet/${s}.svg`,
            alt: "Add to Apple Wallet"
        })
    });
};

const ApplePayLogo = ({ className: o })=>jsx("img", {
        src: "/assets/apple-pay/apple-pay.svg",
        alt: "Apple Pay",
        className: s$6([
            s$3.logo,
            o
        ])
    });

const ApplePayBanner = ()=>{
    let { t: s } = useTranslation();
    return jsxs(Link, {
        to: "/card?action=applePayStartProvision",
        className: s$3.banner,
        children: [
            jsx("p", {
                children: s('apple_pay_banner_text')
            }),
            jsx(ApplePayLogo, {})
        ]
    });
};

const ApplePayWrapper = ({ children: e })=>jsx("div", {
        className: s$3.wrapper,
        children: e
    });

var css_248z$5 = "fieldset {\n  border: none;\n  display: flex;\n  padding: 0;\n}\n\n.PhoneNumberField-module_countryCode__UxdyQ {\n  width: 200px;\n}";
var t = {"countryCode":"PhoneNumberField-module_countryCode__UxdyQ"};
styleInject(css_248z$5);

let n$1 = (e)=>!/^[0-9]*$/g.test(e) && 'error_phone_number';
const PhoneNumberField = ({ phoneNumber: d, countryCode: m, countryCodeOptions: a, onPhoneNumberChange: s, onCountryCodeChange: h, onError: u, placeholder: c, label: p, id: b, isShowLabel: N = !0, error: f })=>{
    let x = useCallback((e)=>h && e.detail && h(e.detail), [
        h
    ]), v = useCallback((e)=>{
        let r = n$1(e);
        r && void 0 !== e ? u(r) : s(e);
    }, [
        h
    ]);
    return jsx("div", {
        className: t.phoneNumber,
        "aria-labelledby": `PhoneNumberField${b}`,
        children: jsxs("fieldset", {
            children: [
                p && N && jsx("legend", {
                    children: jsx("nbx-text", {
                        children: p
                    })
                }),
                jsx("div", {
                    className: t.countryCode,
                    children: jsx(Select, {
                        value: m,
                        onValueChange: x,
                        options: a
                    })
                }),
                jsx(Field, {
                    id: `${b}phoneNumber`,
                    type: 'tel',
                    value: d,
                    onValueChange: v,
                    label: `${b}phoneNumber`,
                    isShowLabel: !1,
                    noLeftBorder: !0,
                    placeholder: c,
                    error: f,
                    size: "medium"
                })
            ]
        })
    });
};

function e(e, r, t, n, o, l, i) {
    try {
        var a = e[l](i), c = a.value;
    } catch (e) {
        t(e);
        return;
    }
    a.done ? r(c) : Promise.resolve(c).then(n, o);
}
let s$2 = window.MICROFRONTENDS_CONFIG;
const Widget = (u)=>{
    var { widget: d, parcelName: p } = u, f = function(e, r) {
        if (null == e) return {};
        var t, n, o = function(e, r) {
            if (null == e) return {};
            var t, n, o = {}, l = Object.keys(e);
            for(n = 0; n < l.length; n++)t = l[n], r.indexOf(t) >= 0 || (o[t] = e[t]);
            return o;
        }(e, r);
        if (Object.getOwnPropertySymbols) {
            var l = Object.getOwnPropertySymbols(e);
            for(n = 0; n < l.length; n++)t = l[n], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
        }
        return o;
    }(u, [
        "widget",
        "parcelName"
    ]);
    let { t: m } = useTranslation(), [b, y] = useState(), g = useCallback(()=>new Promise((r, t)=>{
            var n;
            let o;
            let l = null !== (n = null == s$2 ? void 0 : s$2.widgets[d]) && void 0 !== n ? n : null == s$2 ? void 0 : s$2.apps[d];
            l || t(Error(`Invalid widget selected, ${d}. Abandoning Parcel load.`));
            let { PLATFORM: i } = window, a = `${l}/remoteEntry.js`;
            return 'web' !== i && (a = `/${l}.remoteEntry.js`), new Promise((r, t)=>{
                var n;
                let l = document.createElement("script");
                l.src = a, l.type = "text/javascript", l.async = !0, n = function*() {
                    yield __webpack_init_sharing__('default'), o = window[d], yield o.init(__webpack_share_scopes__.default), r((yield window[d].get(null != p ? p : './app'))());
                }, l.onload = function() {
                    var r = this, t = arguments;
                    return new Promise(function(o, l) {
                        var i = n.apply(r, t);
                        function a(r) {
                            e(i, o, l, a, c, "next", r);
                        }
                        function c(r) {
                            e(i, o, l, a, c, "throw", r);
                        }
                        a(void 0);
                    });
                }, l.onerror = (e)=>{
                    console.error(e), t(e);
                }, document.head.appendChild(l);
            }).then((e)=>{
                r(e.Parcel);
            }).catch((e)=>{
                if ('function' == typeof f.closeModal) {
                    var r;
                    publishErrorNotification({
                        message: null !== (r = f.failureMessage) && void 0 !== r ? r : m('error_title_generic')
                    }), f.closeModal();
                }
                console.error('Widget failed to load:', e), t(e);
            });
        }), [
        f.closeModal,
        p
    ]);
    return (useEffect(()=>{
        g().then(y).catch(console.error);
    }, [
        g
    ]), b) ? jsx(a$1, function(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {}, n = Object.keys(t);
            "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable;
            }))), n.forEach(function(r) {
                var n;
                n = t[r], r in e ? Object.defineProperty(e, r, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[r] = n;
            });
        }
        return e;
    }({
        config: b,
        mountParcel: mountRootParcel
    }, f)) : jsx("div", {
        "aria-label": "loading-parcel"
    });
};

var css_248z$4 = ".RadioGroup-module_radioGroup__fRBy4 {\n  display: flex;\n}\n\n.RadioGroup-module_flexDirectionRow__9u6di {\n  flex-direction: row;\n  gap: 0.4rem;\n}\n\n.RadioGroup-module_flexDirectionColumn__uYait {\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.RadioGroup-module_radioItem__EP5lx {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  cursor: pointer;\n}\n\n.RadioGroup-module_inputContainer__axx8D {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.RadioGroup-module_inputContainer__axx8D > nbx-text {\n  padding-top: 2px;\n}\n.RadioGroup-module_inputContainer__axx8D input[type=radio] {\n  display: none;\n}\n.RadioGroup-module_inputContainer__axx8D input[type=radio] + div {\n  position: relative;\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  border-radius: 50%;\n  border: var(--v2-border-width) solid var(--v2-border-color);\n  transition: background var(--animation-fast), border-color var(--animation-fast);\n}\n.RadioGroup-module_inputContainer__axx8D input[type=radio]:checked + div {\n  border-color: var(--v2-up);\n}\n.RadioGroup-module_inputContainer__axx8D input[type=radio]:checked + div:after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  flex: 0 0 auto;\n  margin-top: -10px;\n  margin-left: -10px;\n  transform: scale(0.5);\n  border-radius: 50%;\n  background: var(--v2-up);\n  transition: background var(--animation-fast);\n}\n\n.RadioGroup-module_inputContainerFlexDirectionRow__7LGxE {\n  gap: 0.6rem;\n}\n\n.RadioGroup-module_inputContainerFlexDirectionColumn__6ksbc {\n  gap: 1rem;\n}\n\n.RadioGroup-module_bordered__zH9H3 {\n  border: 1px solid var(--v2-card-border-color);\n  border-radius: var(--v2-border-radius);\n  padding: 2px 8px;\n}\n\n.RadioGroup-module_bordered__zH9H3.RadioGroup-module_checked__-sFWy {\n  padding: 1px 7px;\n  border: 2px solid var(--v2-up-dark);\n}\n\n.RadioGroup-module_borderPadding__53kFt {\n  padding: 21px;\n}\n\n.RadioGroup-module_borderPadding__53kFt.RadioGroup-module_checked__-sFWy {\n  padding: 20px;\n}\n\nlabel > span {\n  margin-left: 2rem;\n}";
var n = {"radioGroup":"RadioGroup-module_radioGroup__fRBy4","flexDirectionRow":"RadioGroup-module_flexDirectionRow__9u6di","flexDirectionColumn":"RadioGroup-module_flexDirectionColumn__uYait","radioItem":"RadioGroup-module_radioItem__EP5lx","inputContainer":"RadioGroup-module_inputContainer__axx8D","inputContainerFlexDirectionRow":"RadioGroup-module_inputContainerFlexDirectionRow__7LGxE","inputContainerFlexDirectionColumn":"RadioGroup-module_inputContainerFlexDirectionColumn__6ksbc","bordered":"RadioGroup-module_bordered__zH9H3","checked":"RadioGroup-module_checked__-sFWy","borderPadding":"RadioGroup-module_borderPadding__53kFt"};
styleInject(css_248z$4);

const RadioGroupContext = createContext({
    bordered: !1,
    flexDirection: 'column'
});

const RadioGroup = ({ children: t, bordered: a = !1, flexDirection: c = 'column' })=>{
    let l = useMemo(()=>({
            flexDirection: c,
            bordered: a
        }), [
        c,
        a
    ]);
    return jsx(RadioGroupContext.Provider, {
        value: l,
        children: jsx("div", {
            className: s$6(n.radioGroup, {
                [n.flexDirectionRow]: 'row' === c,
                [n.flexDirectionColumn]: 'column' === c
            }),
            children: t
        })
    });
};

const Radio = ({ children: a, value: l, label: m, checked: c, description: d, onChange: s })=>{
    let { bordered: p, flexDirection: u } = useContext(RadioGroupContext);
    return jsxs("label", {
        className: s$6(n.radioItem, {
            [n.bordered]: p,
            [n.borderPadding]: p && 'column' === u,
            [n.checked]: c,
            [n.labelColumn]: 'column' === u,
            [n.labelRow]: 'row' === u
        }),
        children: [
            jsxs("div", {
                className: s$6(n.inputContainer, {
                    [n.inputContainerFlexDirectionRow]: 'row' === u,
                    [n.inputContainerFlexDirectionColumn]: 'column' === u
                }),
                children: [
                    jsx("input", {
                        type: "radio",
                        name: m,
                        value: l,
                        checked: c,
                        onChange: s
                    }),
                    jsx("div", {}),
                    jsx("nbx-text", {
                        tag: "span",
                        children: m
                    })
                ]
            }),
            a && jsx("span", {
                children: a
            }),
            d && jsx("span", {
                children: jsx("nbx-text", {
                    muted: !0,
                    children: d
                })
            })
        ]
    });
};

var css_248z$3 = ".AmountAssetField-module_amountAssetField__hRPGZ {\n  margin-bottom: calc(var(--form-margin-field) / 2);\n}\n\n.AmountAssetField-module_assetIcon__Wi7oQ {\n  padding-left: 12px;\n}\n\n.AmountAssetField-module_fakeIcon__3d67K {\n  padding-left: 19px;\n}\n\n.AmountAssetField-module_assetName__f6LXZ {\n  height: 100%;\n  padding-right: 12px;\n}\n.AmountAssetField-module_assetName__f6LXZ span {\n  line-height: 1;\n}\n.AmountAssetField-module_assetName__f6LXZ nbx-select {\n  margin-right: -12px;\n}\n\n.AmountAssetField-module_centered__9mQ1B {\n  display: flex;\n  justify-content: center;\n}\n\n.AmountAssetField-module_oneAsset__UMYkm {\n  display: flex;\n  align-items: center;\n}";
var l = {"amountAssetField":"AmountAssetField-module_amountAssetField__hRPGZ","assetIcon":"AmountAssetField-module_assetIcon__Wi7oQ","fakeIcon":"AmountAssetField-module_fakeIcon__3d67K","assetName":"AmountAssetField-module_assetName__f6LXZ","centered":"AmountAssetField-module_centered__9mQ1B","oneAsset":"AmountAssetField-module_oneAsset__UMYkm"};
styleInject(css_248z$3);

/*
 *  big.js v6.2.2
 *  A small, fast, easy-to-use library for arbitrary-precision decimal arithmetic.
 *  Copyright (c) 2024 Michael Mclaughlin
 *  https://github.com/MikeMcl/big.js/LICENCE.md
 */


/************************************** EDITABLE DEFAULTS *****************************************/


  // The default values below must be integers within the stated ranges.

  /*
   * The maximum number of decimal places (DP) of the results of operations involving division:
   * div and sqrt, and pow with negative exponents.
   */
var DP = 20,          // 0 to MAX_DP

  /*
   * The rounding mode (RM) used when rounding to the above decimal places.
   *
   *  0  Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
   *  1  To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
   *  2  To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
   *  3  Away from zero.                                  (ROUND_UP)
   */
  RM = 1,             // 0, 1, 2 or 3

  // The maximum value of DP and Big.DP.
  MAX_DP = 1E6,       // 0 to 1000000

  // The maximum magnitude of the exponent argument to the pow method.
  MAX_POWER = 1E6,    // 1 to 1000000

  /*
   * The negative exponent (NE) at and beneath which toString returns exponential notation.
   * (JavaScript numbers: -7)
   * -1000000 is the minimum recommended exponent value of a Big.
   */
  NE = -7,            // 0 to -1000000

  /*
   * The positive exponent (PE) at and above which toString returns exponential notation.
   * (JavaScript numbers: 21)
   * 1000000 is the maximum recommended exponent value of a Big, but this limit is not enforced.
   */
  PE = 21,            // 0 to 1000000

  /*
   * When true, an error will be thrown if a primitive number is passed to the Big constructor,
   * or if valueOf is called, or if toNumber is called on a Big which cannot be converted to a
   * primitive number without a loss of precision.
   */
  STRICT = false,     // true or false


/**************************************************************************************************/


  // Error messages.
  NAME = '[big.js] ',
  INVALID = NAME + 'Invalid ',
  INVALID_DP = INVALID + 'decimal places',
  INVALID_RM = INVALID + 'rounding mode',
  DIV_BY_ZERO = NAME + 'Division by zero',

  // The shared prototype object.
  P = {},
  UNDEFINED = void 0,
  NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;


/*
 * Create and return a Big constructor.
 */
function _Big_() {

  /*
   * The Big constructor and exported function.
   * Create and return a new instance of a Big number object.
   *
   * n {number|string|Big} A numeric value.
   */
  function Big(n) {
    var x = this;

    // Enable constructor usage without new.
    if (!(x instanceof Big)) return n === UNDEFINED ? _Big_() : new Big(n);

    // Duplicate.
    if (n instanceof Big) {
      x.s = n.s;
      x.e = n.e;
      x.c = n.c.slice();
    } else {
      if (typeof n !== 'string') {
        if (Big.strict === true && typeof n !== 'bigint') {
          throw TypeError(INVALID + 'value');
        }

        // Minus zero?
        n = n === 0 && 1 / n < 0 ? '-0' : String(n);
      }

      parse(x, n);
    }

    // Retain a reference to this Big constructor.
    // Shadow Big.prototype.constructor which points to Object.
    x.constructor = Big;
  }

  Big.prototype = P;
  Big.DP = DP;
  Big.RM = RM;
  Big.NE = NE;
  Big.PE = PE;
  Big.strict = STRICT;
  Big.roundDown = 0;
  Big.roundHalfUp = 1;
  Big.roundHalfEven = 2;
  Big.roundUp = 3;

  return Big;
}


/*
 * Parse the number or string value passed to a Big constructor.
 *
 * x {Big} A Big number instance.
 * n {number|string} A numeric value.
 */
function parse(x, n) {
  var e, i, nl;

  if (!NUMERIC.test(n)) {
    throw Error(INVALID + 'number');
  }

  // Determine sign.
  x.s = n.charAt(0) == '-' ? (n = n.slice(1), -1) : 1;

  // Decimal point?
  if ((e = n.indexOf('.')) > -1) n = n.replace('.', '');

  // Exponential form?
  if ((i = n.search(/e/i)) > 0) {

    // Determine exponent.
    if (e < 0) e = i;
    e += +n.slice(i + 1);
    n = n.substring(0, i);
  } else if (e < 0) {

    // Integer.
    e = n.length;
  }

  nl = n.length;

  // Determine leading zeros.
  for (i = 0; i < nl && n.charAt(i) == '0';) ++i;

  if (i == nl) {

    // Zero.
    x.c = [x.e = 0];
  } else {

    // Determine trailing zeros.
    for (; nl > 0 && n.charAt(--nl) == '0';);
    x.e = e - i - 1;
    x.c = [];

    // Convert string to array of digits without leading/trailing zeros.
    for (e = 0; i <= nl;) x.c[e++] = +n.charAt(i++);
  }

  return x;
}


/*
 * Round Big x to a maximum of sd significant digits using rounding mode rm.
 *
 * x {Big} The Big to round.
 * sd {number} Significant digits: integer, 0 to MAX_DP inclusive.
 * rm {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 * [more] {boolean} Whether the result of division was truncated.
 */
function round(x, sd, rm, more) {
  var xc = x.c;

  if (rm === UNDEFINED) rm = x.constructor.RM;
  if (rm !== 0 && rm !== 1 && rm !== 2 && rm !== 3) {
    throw Error(INVALID_RM);
  }

  if (sd < 1) {
    more =
      rm === 3 && (more || !!xc[0]) || sd === 0 && (
      rm === 1 && xc[0] >= 5 ||
      rm === 2 && (xc[0] > 5 || xc[0] === 5 && (more || xc[1] !== UNDEFINED))
    );

    xc.length = 1;

    if (more) {

      // 1, 0.1, 0.01, 0.001, 0.0001 etc.
      x.e = x.e - sd + 1;
      xc[0] = 1;
    } else {

      // Zero.
      xc[0] = x.e = 0;
    }
  } else if (sd < xc.length) {

    // xc[sd] is the digit after the digit that may be rounded up.
    more =
      rm === 1 && xc[sd] >= 5 ||
      rm === 2 && (xc[sd] > 5 || xc[sd] === 5 &&
        (more || xc[sd + 1] !== UNDEFINED || xc[sd - 1] & 1)) ||
      rm === 3 && (more || !!xc[0]);

    // Remove any digits after the required precision.
    xc.length = sd;

    // Round up?
    if (more) {

      // Rounding up may mean the previous digit has to be rounded up.
      for (; ++xc[--sd] > 9;) {
        xc[sd] = 0;
        if (sd === 0) {
          ++x.e;
          xc.unshift(1);
          break;
        }
      }
    }

    // Remove trailing zeros.
    for (sd = xc.length; !xc[--sd];) xc.pop();
  }

  return x;
}


/*
 * Return a string representing the value of Big x in normal or exponential notation.
 * Handles P.toExponential, P.toFixed, P.toJSON, P.toPrecision, P.toString and P.valueOf.
 */
function stringify(x, doExponential, isNonzero) {
  var e = x.e,
    s = x.c.join(''),
    n = s.length;

  // Exponential notation?
  if (doExponential) {
    s = s.charAt(0) + (n > 1 ? '.' + s.slice(1) : '') + (e < 0 ? 'e' : 'e+') + e;

  // Normal notation.
  } else if (e < 0) {
    for (; ++e;) s = '0' + s;
    s = '0.' + s;
  } else if (e > 0) {
    if (++e > n) {
      for (e -= n; e--;) s += '0';
    } else if (e < n) {
      s = s.slice(0, e) + '.' + s.slice(e);
    }
  } else if (n > 1) {
    s = s.charAt(0) + '.' + s.slice(1);
  }

  return x.s < 0 && isNonzero ? '-' + s : s;
}


// Prototype/instance methods


/*
 * Return a new Big whose value is the absolute value of this Big.
 */
P.abs = function () {
  var x = new this.constructor(this);
  x.s = 1;
  return x;
};


/*
 * Return 1 if the value of this Big is greater than the value of Big y,
 *       -1 if the value of this Big is less than the value of Big y, or
 *        0 if they have the same value.
 */
P.cmp = function (y) {
  var isneg,
    x = this,
    xc = x.c,
    yc = (y = new x.constructor(y)).c,
    i = x.s,
    j = y.s,
    k = x.e,
    l = y.e;

  // Either zero?
  if (!xc[0] || !yc[0]) return !xc[0] ? !yc[0] ? 0 : -j : i;

  // Signs differ?
  if (i != j) return i;

  isneg = i < 0;

  // Compare exponents.
  if (k != l) return k > l ^ isneg ? 1 : -1;

  j = (k = xc.length) < (l = yc.length) ? k : l;

  // Compare digit by digit.
  for (i = -1; ++i < j;) {
    if (xc[i] != yc[i]) return xc[i] > yc[i] ^ isneg ? 1 : -1;
  }

  // Compare lengths.
  return k == l ? 0 : k > l ^ isneg ? 1 : -1;
};


/*
 * Return a new Big whose value is the value of this Big divided by the value of Big y, rounded,
 * if necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
 */
P.div = function (y) {
  var x = this,
    Big = x.constructor,
    a = x.c,                  // dividend
    b = (y = new Big(y)).c,   // divisor
    k = x.s == y.s ? 1 : -1,
    dp = Big.DP;

  if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
    throw Error(INVALID_DP);
  }

  // Divisor is zero?
  if (!b[0]) {
    throw Error(DIV_BY_ZERO);
  }

  // Dividend is 0? Return +-0.
  if (!a[0]) {
    y.s = k;
    y.c = [y.e = 0];
    return y;
  }

  var bl, bt, n, cmp, ri,
    bz = b.slice(),
    ai = bl = b.length,
    al = a.length,
    r = a.slice(0, bl),   // remainder
    rl = r.length,
    q = y,                // quotient
    qc = q.c = [],
    qi = 0,
    p = dp + (q.e = x.e - y.e) + 1;    // precision of the result

  q.s = k;
  k = p < 0 ? 0 : p;

  // Create version of divisor with leading zero.
  bz.unshift(0);

  // Add zeros to make remainder as long as divisor.
  for (; rl++ < bl;) r.push(0);

  do {

    // n is how many times the divisor goes into current remainder.
    for (n = 0; n < 10; n++) {

      // Compare divisor and remainder.
      if (bl != (rl = r.length)) {
        cmp = bl > rl ? 1 : -1;
      } else {
        for (ri = -1, cmp = 0; ++ri < bl;) {
          if (b[ri] != r[ri]) {
            cmp = b[ri] > r[ri] ? 1 : -1;
            break;
          }
        }
      }

      // If divisor < remainder, subtract divisor from remainder.
      if (cmp < 0) {

        // Remainder can't be more than 1 digit longer than divisor.
        // Equalise lengths using divisor with extra leading zero?
        for (bt = rl == bl ? b : bz; rl;) {
          if (r[--rl] < bt[rl]) {
            ri = rl;
            for (; ri && !r[--ri];) r[ri] = 9;
            --r[ri];
            r[rl] += 10;
          }
          r[rl] -= bt[rl];
        }

        for (; !r[0];) r.shift();
      } else {
        break;
      }
    }

    // Add the digit n to the result array.
    qc[qi++] = cmp ? n : ++n;

    // Update the remainder.
    if (r[0] && cmp) r[rl] = a[ai] || 0;
    else r = [a[ai]];

  } while ((ai++ < al || r[0] !== UNDEFINED) && k--);

  // Leading zero? Do not remove if result is simply zero (qi == 1).
  if (!qc[0] && qi != 1) {

    // There can't be more than one zero.
    qc.shift();
    q.e--;
    p--;
  }

  // Round?
  if (qi > p) round(q, p, Big.RM, r[0] !== UNDEFINED);

  return q;
};


/*
 * Return true if the value of this Big is equal to the value of Big y, otherwise return false.
 */
P.eq = function (y) {
  return this.cmp(y) === 0;
};


/*
 * Return true if the value of this Big is greater than the value of Big y, otherwise return
 * false.
 */
P.gt = function (y) {
  return this.cmp(y) > 0;
};


/*
 * Return true if the value of this Big is greater than or equal to the value of Big y, otherwise
 * return false.
 */
P.gte = function (y) {
  return this.cmp(y) > -1;
};


/*
 * Return true if the value of this Big is less than the value of Big y, otherwise return false.
 */
P.lt = function (y) {
  return this.cmp(y) < 0;
};


/*
 * Return true if the value of this Big is less than or equal to the value of Big y, otherwise
 * return false.
 */
P.lte = function (y) {
  return this.cmp(y) < 1;
};


/*
 * Return a new Big whose value is the value of this Big minus the value of Big y.
 */
P.minus = P.sub = function (y) {
  var i, j, t, xlty,
    x = this,
    Big = x.constructor,
    a = x.s,
    b = (y = new Big(y)).s;

  // Signs differ?
  if (a != b) {
    y.s = -b;
    return x.plus(y);
  }

  var xc = x.c.slice(),
    xe = x.e,
    yc = y.c,
    ye = y.e;

  // Either zero?
  if (!xc[0] || !yc[0]) {
    if (yc[0]) {
      y.s = -b;
    } else if (xc[0]) {
      y = new Big(x);
    } else {
      y.s = 1;
    }
    return y;
  }

  // Determine which is the bigger number. Prepend zeros to equalise exponents.
  if (a = xe - ye) {

    if (xlty = a < 0) {
      a = -a;
      t = xc;
    } else {
      ye = xe;
      t = yc;
    }

    t.reverse();
    for (b = a; b--;) t.push(0);
    t.reverse();
  } else {

    // Exponents equal. Check digit by digit.
    j = ((xlty = xc.length < yc.length) ? xc : yc).length;

    for (a = b = 0; b < j; b++) {
      if (xc[b] != yc[b]) {
        xlty = xc[b] < yc[b];
        break;
      }
    }
  }

  // x < y? Point xc to the array of the bigger number.
  if (xlty) {
    t = xc;
    xc = yc;
    yc = t;
    y.s = -y.s;
  }

  /*
   * Append zeros to xc if shorter. No need to add zeros to yc if shorter as subtraction only
   * needs to start at yc.length.
   */
  if ((b = (j = yc.length) - (i = xc.length)) > 0) for (; b--;) xc[i++] = 0;

  // Subtract yc from xc.
  for (b = i; j > a;) {
    if (xc[--j] < yc[j]) {
      for (i = j; i && !xc[--i];) xc[i] = 9;
      --xc[i];
      xc[j] += 10;
    }

    xc[j] -= yc[j];
  }

  // Remove trailing zeros.
  for (; xc[--b] === 0;) xc.pop();

  // Remove leading zeros and adjust exponent accordingly.
  for (; xc[0] === 0;) {
    xc.shift();
    --ye;
  }

  if (!xc[0]) {

    // n - n = +0
    y.s = 1;

    // Result must be zero.
    xc = [ye = 0];
  }

  y.c = xc;
  y.e = ye;

  return y;
};


/*
 * Return a new Big whose value is the value of this Big modulo the value of Big y.
 */
P.mod = function (y) {
  var ygtx,
    x = this,
    Big = x.constructor,
    a = x.s,
    b = (y = new Big(y)).s;

  if (!y.c[0]) {
    throw Error(DIV_BY_ZERO);
  }

  x.s = y.s = 1;
  ygtx = y.cmp(x) == 1;
  x.s = a;
  y.s = b;

  if (ygtx) return new Big(x);

  a = Big.DP;
  b = Big.RM;
  Big.DP = Big.RM = 0;
  x = x.div(y);
  Big.DP = a;
  Big.RM = b;

  return this.minus(x.times(y));
};


/*
 * Return a new Big whose value is the value of this Big negated.
 */
P.neg = function () {
  var x = new this.constructor(this);
  x.s = -x.s;
  return x;
};


/*
 * Return a new Big whose value is the value of this Big plus the value of Big y.
 */
P.plus = P.add = function (y) {
  var e, k, t,
    x = this,
    Big = x.constructor;

  y = new Big(y);

  // Signs differ?
  if (x.s != y.s) {
    y.s = -y.s;
    return x.minus(y);
  }

  var xe = x.e,
    xc = x.c,
    ye = y.e,
    yc = y.c;

  // Either zero?
  if (!xc[0] || !yc[0]) {
    if (!yc[0]) {
      if (xc[0]) {
        y = new Big(x);
      } else {
        y.s = x.s;
      }
    }
    return y;
  }

  xc = xc.slice();

  // Prepend zeros to equalise exponents.
  // Note: reverse faster than unshifts.
  if (e = xe - ye) {
    if (e > 0) {
      ye = xe;
      t = yc;
    } else {
      e = -e;
      t = xc;
    }

    t.reverse();
    for (; e--;) t.push(0);
    t.reverse();
  }

  // Point xc to the longer array.
  if (xc.length - yc.length < 0) {
    t = yc;
    yc = xc;
    xc = t;
  }

  e = yc.length;

  // Only start adding at yc.length - 1 as the further digits of xc can be left as they are.
  for (k = 0; e; xc[e] %= 10) k = (xc[--e] = xc[e] + yc[e] + k) / 10 | 0;

  // No need to check for zero, as +x + +y != 0 && -x + -y != 0

  if (k) {
    xc.unshift(k);
    ++ye;
  }

  // Remove trailing zeros.
  for (e = xc.length; xc[--e] === 0;) xc.pop();

  y.c = xc;
  y.e = ye;

  return y;
};


/*
 * Return a Big whose value is the value of this Big raised to the power n.
 * If n is negative, round to a maximum of Big.DP decimal places using rounding
 * mode Big.RM.
 *
 * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
 */
P.pow = function (n) {
  var x = this,
    one = new x.constructor('1'),
    y = one,
    isneg = n < 0;

  if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) {
    throw Error(INVALID + 'exponent');
  }

  if (isneg) n = -n;

  for (;;) {
    if (n & 1) y = y.times(x);
    n >>= 1;
    if (!n) break;
    x = x.times(x);
  }

  return isneg ? one.div(y) : y;
};


/*
 * Return a new Big whose value is the value of this Big rounded to a maximum precision of sd
 * significant digits using rounding mode rm, or Big.RM if rm is not specified.
 *
 * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 */
P.prec = function (sd, rm) {
  if (sd !== ~~sd || sd < 1 || sd > MAX_DP) {
    throw Error(INVALID + 'precision');
  }
  return round(new this.constructor(this), sd, rm);
};


/*
 * Return a new Big whose value is the value of this Big rounded to a maximum of dp decimal places
 * using rounding mode rm, or Big.RM if rm is not specified.
 * If dp is negative, round to an integer which is a multiple of 10**-dp.
 * If dp is not specified, round to 0 decimal places.
 *
 * dp? {number} Integer, -MAX_DP to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 */
P.round = function (dp, rm) {
  if (dp === UNDEFINED) dp = 0;
  else if (dp !== ~~dp || dp < -MAX_DP || dp > MAX_DP) {
    throw Error(INVALID_DP);
  }
  return round(new this.constructor(this), dp + this.e + 1, rm);
};


/*
 * Return a new Big whose value is the square root of the value of this Big, rounded, if
 * necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
 */
P.sqrt = function () {
  var r, c, t,
    x = this,
    Big = x.constructor,
    s = x.s,
    e = x.e,
    half = new Big('0.5');

  // Zero?
  if (!x.c[0]) return new Big(x);

  // Negative?
  if (s < 0) {
    throw Error(NAME + 'No square root');
  }

  // Estimate.
  s = Math.sqrt(+stringify(x, true, true));

  // Math.sqrt underflow/overflow?
  // Re-estimate: pass x coefficient to Math.sqrt as integer, then adjust the result exponent.
  if (s === 0 || s === 1 / 0) {
    c = x.c.join('');
    if (!(c.length + e & 1)) c += '0';
    s = Math.sqrt(c);
    e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
    r = new Big((s == 1 / 0 ? '5e' : (s = s.toExponential()).slice(0, s.indexOf('e') + 1)) + e);
  } else {
    r = new Big(s + '');
  }

  e = r.e + (Big.DP += 4);

  // Newton-Raphson iteration.
  do {
    t = r;
    r = half.times(t.plus(x.div(t)));
  } while (t.c.slice(0, e).join('') !== r.c.slice(0, e).join(''));

  return round(r, (Big.DP -= 4) + r.e + 1, Big.RM);
};


/*
 * Return a new Big whose value is the value of this Big times the value of Big y.
 */
P.times = P.mul = function (y) {
  var c,
    x = this,
    Big = x.constructor,
    xc = x.c,
    yc = (y = new Big(y)).c,
    a = xc.length,
    b = yc.length,
    i = x.e,
    j = y.e;

  // Determine sign of result.
  y.s = x.s == y.s ? 1 : -1;

  // Return signed 0 if either 0.
  if (!xc[0] || !yc[0]) {
    y.c = [y.e = 0];
    return y;
  }

  // Initialise exponent of result as x.e + y.e.
  y.e = i + j;

  // If array xc has fewer digits than yc, swap xc and yc, and lengths.
  if (a < b) {
    c = xc;
    xc = yc;
    yc = c;
    j = a;
    a = b;
    b = j;
  }

  // Initialise coefficient array of result with zeros.
  for (c = new Array(j = a + b); j--;) c[j] = 0;

  // Multiply.

  // i is initially xc.length.
  for (i = b; i--;) {
    b = 0;

    // a is yc.length.
    for (j = a + i; j > i;) {

      // Current sum of products at this digit position, plus carry.
      b = c[j] + yc[i] * xc[j - i - 1] + b;
      c[j--] = b % 10;

      // carry
      b = b / 10 | 0;
    }

    c[j] = b;
  }

  // Increment result exponent if there is a final carry, otherwise remove leading zero.
  if (b) ++y.e;
  else c.shift();

  // Remove trailing zeros.
  for (i = c.length; !c[--i];) c.pop();
  y.c = c;

  return y;
};


/*
 * Return a string representing the value of this Big in exponential notation rounded to dp fixed
 * decimal places using rounding mode rm, or Big.RM if rm is not specified.
 *
 * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 */
P.toExponential = function (dp, rm) {
  var x = this,
    n = x.c[0];

  if (dp !== UNDEFINED) {
    if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
      throw Error(INVALID_DP);
    }
    x = round(new x.constructor(x), ++dp, rm);
    for (; x.c.length < dp;) x.c.push(0);
  }

  return stringify(x, true, !!n);
};


/*
 * Return a string representing the value of this Big in normal notation rounded to dp fixed
 * decimal places using rounding mode rm, or Big.RM if rm is not specified.
 *
 * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 *
 * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
 * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
 */
P.toFixed = function (dp, rm) {
  var x = this,
    n = x.c[0];

  if (dp !== UNDEFINED) {
    if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
      throw Error(INVALID_DP);
    }
    x = round(new x.constructor(x), dp + x.e + 1, rm);

    // x.e may have changed if the value is rounded up.
    for (dp = dp + x.e + 1; x.c.length < dp;) x.c.push(0);
  }

  return stringify(x, false, !!n);
};


/*
 * Return a string representing the value of this Big.
 * Return exponential notation if this Big has a positive exponent equal to or greater than
 * Big.PE, or a negative exponent equal to or less than Big.NE.
 * Omit the sign for negative zero.
 */
P[Symbol.for('nodejs.util.inspect.custom')] = P.toJSON = P.toString = function () {
  var x = this,
    Big = x.constructor;
  return stringify(x, x.e <= Big.NE || x.e >= Big.PE, !!x.c[0]);
};


/*
 * Return the value of this Big as a primitve number.
 */
P.toNumber = function () {
  var n = +stringify(this, true, true);
  if (this.constructor.strict === true && !this.eq(n.toString())) {
    throw Error(NAME + 'Imprecise conversion');
  }
  return n;
};


/*
 * Return a string representing the value of this Big rounded to sd significant digits using
 * rounding mode rm, or Big.RM if rm is not specified.
 * Use exponential notation if sd is less than the number of digits necessary to represent
 * the integer part of the value in normal notation.
 *
 * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 */
P.toPrecision = function (sd, rm) {
  var x = this,
    Big = x.constructor,
    n = x.c[0];

  if (sd !== UNDEFINED) {
    if (sd !== ~~sd || sd < 1 || sd > MAX_DP) {
      throw Error(INVALID + 'precision');
    }
    x = round(new Big(x), sd, rm);
    for (; x.c.length < sd;) x.c.push(0);
  }

  return stringify(x, sd <= x.e || x.e <= Big.NE || x.e >= Big.PE, !!n);
};


/*
 * Return a string representing the value of this Big.
 * Return exponential notation if this Big has a positive exponent equal to or greater than
 * Big.PE, or a negative exponent equal to or less than Big.NE.
 * Include the sign for negative zero.
 */
P.valueOf = function () {
  var x = this,
    Big = x.constructor;
  if (Big.strict === true) {
    throw Error(NAME + 'valueOf disallowed');
  }
  return stringify(x, x.e <= Big.NE || x.e >= Big.PE, true);
};


// Export


var Big = _Big_();

let r = /^(\d+)?(\.|,)?(\d+)?$/;
const AmountAssetField = ({ id: o, label: d, asset: m, placeholder: c, value: u, error: p, onChange: h = ()=>{}, onInputError: g = ()=>{}, assetChoices: v = [], onChangeAsset: b = ()=>{}, readonly: f = !1, dispalyTrailingLabel: x = !0 })=>{
    let A = useCallback((e)=>{
        var t;
        let i = null === (t = e.currentTarget.value) || void 0 === t ? void 0 : t.replace(',', '.');
        try {
            i && Big(i), (null == i ? void 0 : i.length) > 20 || !r.test(i) || void 0 !== i && '' !== i && 0 > +i ? g() : h(i);
        } catch (e) {
            g();
        }
    }, []);
    return jsx("div", {
        className: l.amountAssetField,
        children: jsxs("nbx-field", {
            inputid: o,
            label: d,
            hidelabel: !0,
            value: u,
            error: p,
            onKeyUp: A,
            readonly: f,
            inputmode: "decimal",
            autocomplete: !1,
            placeholder: c,
            bigfield: !0,
            ignoremarginbottom: !0,
            children: [
                jsx("div", {
                    slot: "input-leading",
                    className: s$6(l.centered, l.assetIcon),
                    children: jsx("nbx-asset-icon", {
                        size: "32",
                        asset: m
                    }, m)
                }),
                jsx("div", {
                    slot: "input-trailing",
                    className: s$6(l.centered, l.assetName),
                    children: v.length > 1 ? jsx(Select, {
                        value: m,
                        options: v,
                        instanttrade: !0,
                        muted: '' === u,
                        onValueChange: (e)=>b(e.detail)
                    }) : x && jsx("span", {
                        className: l.oneAsset,
                        children: jsx("nbx-text", {
                            weight: "medium",
                            muted: '' === u,
                            children: m
                        })
                    })
                })
            ]
        })
    });
};

const AvailableBalance = ({ asset: i, available: m, assets: o, isLoading: s = !1 })=>{
    let { t: c } = useTranslation();
    return jsxs("span", {
        className: "available-balance",
        children: [
            jsx("nbx-text", {
                muted: !0,
                children: useIsMobile() ? `${c('qb_balance')}: ` : `${c('qb_avail_balance')}: `
            }),
            jsx("span", {
                className: "spacer"
            }),
            jsx(FadeInContainer, {
                children: !s && void 0 !== m && o && i && jsxs("nbx-text", {
                    muted: !0,
                    children: [
                        formatAsset(m, i, o),
                        " ",
                        i
                    ]
                })
            })
        ]
    });
};

var css_248z$2 = ".PercentageBalanceButtons-module_quickAmounts__x8hs0 {\n  display: flex;\n  justify-content: space-evenly;\n  gap: 0.2rem;\n}\n.PercentageBalanceButtons-module_quickAmounts__x8hs0 > * {\n  flex: 1;\n}\n\n.PercentageBalanceButtons-module_percentageBalance__7eqHL {\n  display: flex;\n  justify-content: center;\n}\n.PercentageBalanceButtons-module_percentageBalance__7eqHL > * {\n  flex: 1;\n}";
var o = {"quickAmounts":"PercentageBalanceButtons-module_quickAmounts__x8hs0","percentageBalance":"PercentageBalanceButtons-module_percentageBalance__7eqHL"};
styleInject(css_248z$2);

var css_248z$1 = ".Buttons-module_buttons__RxlWy {\n  display: flex;\n}\n\n.Buttons-module_buttons__RxlWy button {\n  flex: 1;\n  display: inline-block;\n  cursor: pointer;\n  outline: none;\n  position: relative;\n  font-family: inherit;\n  font-size: var(--v2-font-size-button);\n  font-weight: var(--font-weight-bold);\n  letter-spacing: 0.01em;\n  padding: 0px 8px;\n  height: var(--button-height);\n  margin: 0;\n  background: var(--v2-button-bg);\n  color: var(--v2-text);\n  width: auto;\n  transition: color var(--animation-theme), background var(--animation-theme), border-color var(--animation-theme), opacity var(--animation-theme);\n  border: var(--v2-border-width) solid var(--v2-input-border);\n  border-left: none;\n}\n.Buttons-module_buttons__RxlWy button:hover {\n  background: var(--v2-button-bg-hover);\n}\n.Buttons-module_buttons__RxlWy button > span {\n  line-height: 1;\n}\n\n.Buttons-module_buttons__RxlWy button span {\n  width: 100%;\n  height: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.Buttons-module_buttons__RxlWy button:first-child {\n  border: var(--v2-border-width) solid var(--v2-input-border);\n  border-top-left-radius: calc(var(--button-height) / 2);\n  border-bottom-left-radius: calc(var(--button-height) / 2);\n  padding-left: 14px;\n}\n\n.Buttons-module_buttons__RxlWy button:last-child {\n  border: var(--v2-border-width) solid var(--v2-input-border);\n  border-left: 0;\n  border-top-right-radius: calc(var(--button-height) / 2);\n  border-bottom-right-radius: calc(var(--button-height) / 2);\n  padding-right: 14px;\n}";
var s$1 = {"buttons":"Buttons-module_buttons__RxlWy"};
styleInject(css_248z$1);

const Buttons = ({ buttons: o })=>jsx("div", {
        className: s$1.buttons,
        children: o.map(({ label: s, onClick: o })=>jsx("button", {
                onClick: o,
                children: jsx("span", {
                    children: s
                })
            }, s))
    });

let i = [
    10,
    25,
    50,
    75,
    100
];
const PercentageBalanceButtons = ({ available: t, onChange: s, asset: c, assets: l, precision: m })=>jsx("div", {
        className: o.percentageBalance,
        children: jsx(FadeInContainer, {
            children: jsx("div", {
                className: o.quickAmounts,
                children: jsx(Buttons, {
                    buttons: i.map((e)=>({
                            label: 100 === e ? 'MAX' : `${e}%`,
                            onClick: ()=>t && s(Big(t).mul(e).div(100).round(null != m ? m : (l && c ? l[c.toUpperCase()] : {
                                    decimalPrecisionDisplay: 2
                                }).decimalPrecisionDisplay, Big.roundDown))
                        }))
                })
            })
        })
    });

const Amount = ({ amount: i, asset: s, assets: o, displayIcon: x = !1, displayAsset: m = !0, wrapAsset: a })=>jsxs(FadeInContainer, {
        children: [
            x && jsx("nbx-asset-icon", {
                size: "18",
                asset: s,
                style: {
                    marginRight: '5px'
                }
            }, s),
            jsx("nbx-text", {
                monospaced: !0,
                children: formatAsset(i, s, o)
            }),
            m && (a ? jsx("div", {
                children: jsx("nbx-text", {
                    textAlign: 'right',
                    muted: !0,
                    children: s
                })
            }) : jsx("nbx-text", {
                muted: !0,
                style: {
                    marginLeft: '5px'
                },
                children: s
            }))
        ]
    });

var css_248z = ".Page-module_page__3YFuz {\n  position: relative;\n  min-height: 50vh;\n  width: 100%;\n  max-width: calc(var(--base-max-page-width) + 2 * var(--viewport-padding));\n  margin: 0 auto;\n  padding: 1rem var(--viewport-padding) 0;\n  display: flex;\n  flex-direction: column;\n}\n@media (min-width: 1367px) {\n  .Page-module_page__3YFuz {\n    max-width: calc(var(--base-max-page-width) + var(--viewport-padding));\n    padding: 0 var(--viewport-padding) 0 0;\n  }\n}";
var s = {"page":"Page-module_page__3YFuz"};
styleInject(css_248z);

const Page = ({ children: r })=>jsx("div", {
        className: s.page,
        children: r
    });

export { Accordion, AddToAppleWallet, Amount, AmountAssetField, AppError, ApplePayBanner, ApplePayLogo, ApplePayWrapper, AvailableBalance, BiometricGate, Box, Button, ButtonIcon, Buttons, ComingSoon, Entries, Entry, FadeInContainer, Field, GridItems, Img, Line, Loading, Message, ModalPane, MsgDone, MsgError, NUMBER_FIELD_INPUT_ERRORS, NumberField, Page, PercentageBalanceButtons, PhoneNumberField, Radio, RadioGroup, RangeSlider, ScrollableHorizontalNav, Select, Spinner, StepBar, Table, Text, Widget };
